<template>
  <div class="sjj">
    <v-LeftSource> </v-LeftSource>
    <div class="dataSet" v-loading="allLoad">
      <div class="leftSet">
        <div class="leftTil">
          <FSpanTil fontSize="16">{{dataSet.activeType.dateSourceName || ''}}</FSpanTil>
          <div class="divSvg">
            <FSvg title="刷新" color="#666" IconSize="22" @click.native="getDialog(0)"></FSvg>
          </div>
        </div>
        <div class="leftList">
          <div class="list_til noSelect">
            <span class="divSpan" :class="{addDivSpan:dataSetType===0&&dataSet.activeType.type!==0,oneDivSpan:dataSet.activeType.type===0}" @click="getDataSetType(0)" v-show="dataSet.activeType.type!==0">原表导入</span>
            <span class="divSpan" :class="{addDivSpan:dataSetType===1}" @click="getDataSetType(1)" v-show="dataSet.activeType.type!==0">自定义数据</span>
          </div>
          <div class="listUl_count" v-loading="dataSet.load">
            <ul class="listUl" v-if="dataSetType===0&&dataSet.origList.length">
              <li v-for="(item,index) in dataSet.origList" :class="{addValList:activeDataSet.orig===index}" @click="getOrigClick(index,item)" :key="index">
                <img v-if="!item.tableType" src="../../../../assets/common/image/blueicon.png">
                <img v-if="item.tableType" src="../../../../assets/common/image/yellowicon.png">
                {{item.tableName}}
              </li>
            </ul>
            <ul class="listUl" v-if="dataSetType===1&&dataSet.SQLList.length">
              <li v-for="(item,index) in dataSet.SQLList" :key="index" :class="{addValList:activeDataSet.SQL===index}" @click="getSQLClick(index)">
                <span>{{item}}</span>
              </li>
            </ul>
            <div class="comNoData" v-if="dataSetType===0&&!dataSet.origList.length||dataSetType===1&&!dataSet.SQLList.length"><span>暂无数据</span></div>
          </div>
        </div>
        <div class="leftBomList">
          <div class="list_til noSelect">
            <FSpanTil fontSize="18" fontWeight="bold">数据准备列表</FSpanTil>
          </div>

          <div class="listUl_count" v-loading="dataSetBom.load">
            <ul class="listUl" v-if="dataSetBom.list.length">
              <li v-for="item in dataSetBom.list" :key="item.index">
                <span>{{item.dataSetName}}</span>
                <FSvg title="删除" color="#666" IconSize="20" @click.native="getBomReomve(item)"></FSvg>
                <FSvg title="下一步" IconSize="22" @click.native="getBomRoute(item)"></FSvg>
              </li>
            </ul>
            <div class="comNoData" v-if="!dataSetBom.list.length"><span>暂无数据</span></div>
          </div>
        </div>
      </div>
      <div class="rigSet">
        <div class="type_0" v-if="dataSetType===0">
          <div class="rigTil">
            <div>
              <!-- <FSvg title="图表" color="transparent" hoverColor="#333"></FSvg> -->
            </div>
            <!-- <span>{{origData.til||''}}</span> -->
            <FBtn type="8" @click="delDialog(0)">
              删除字段
              <FSvg title="消息" IconSize="16" v-if="this.alreadyDel!=0"></FSvg>
            </FBtn>
            <FBtn type="7" @click="addDialog(0)">数据扩充
              <el-dropdown style="list-style:none" @command="clickDropdown">
                <h4 style="font-weight:normal;color:#002774" class="el-dropdown-link">
                  【{{addNum}}】
                </h4>
                <el-dropdown-menu slot="dropdown" v-if="this.addName.length != 0">
                  <el-dropdown-item v-for="(item,index) in addName" :key="index" :command="item">{{item}}
                    <el-button type="text" @click.native.stop="open2(index)">
                      <!-- @click.native.stop="cha(index)" -->
                      <FSvg title="叉" IconSize="16" style="float:right;margin-left:20px;" color="orange" hoverColor="#666"></FSvg>
                    </el-button>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </FBtn>
            <FBtn type="9" @click="tableDialog(0)">数据关联
              <el-dropdown style="list-style:none" @command="clickDropdown">
                <h4 style="font-weight:normal;color:#002774" class="el-dropdown-link">
                  【{{tableAssociationListLength}}】
                </h4>
                <el-dropdown-menu slot="dropdown" v-if="this.tableAssociationList.length != 0">
                  <el-dropdown-item v-for="(item,index) in tableAssociationList" :key="index" :command="item">{{item}}
                    <el-button type="text" @click.native.stop="open(index)">
                      <!-- @click.native.stop="chaTable(index)" -->
                      <FSvg title="叉" IconSize="16" style="float:right;margin-left:20px" color="orange" hoverColor="#666"></FSvg>
                    </el-button>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </FBtn>
            <FBtn type="15" @click="clearDialog(0)">
              数据过滤
              <FSvg title="消息" IconSize="16" v-if="this.alreadyScreen!=''"></FSvg>
            </FBtn>
            <FBtn type="15" @click="changeDialog(0)">
              格式转换
              <!-- <FSvg title="消息" IconSize="16" v-if="this.alreadyScreen!=''"></FSvg> -->
            </FBtn>
          </div>
          <div class="rigCount">
            <div class="rigCount_div">
              <el-table :data="origData.tableList" border lazy v-loading="origData.load" style="width: 100%; border-radius:10px 10px 0 0;">
                <el-table-column v-for="item in origData.tableProp" :key="item.index" :prop="item.prop" :show-overflow-tooltip="true" align="center" :label="item.label">
                </el-table-column>
              </el-table>
            </div>
          </div>
          <FPage :pageSize="tableData.pageSize" :total="tableData.total" @page="getPage"></FPage>
          <FBtn type="1" @click="getSaveName(0)">保存</FBtn>
        </div>
        <div class="type_1" v-if="dataSetType===1">
          <div class="type_1_sql">
            <textarea ref="textarea" class="form-control" id="codeSQL"></textarea>
            <div class="btn_div">
              <FBtn type="2" @click="getSQLValue(1)">执行</FBtn>
            </div>
          </div>
          <div class="type_1_table">
            <div class="rigTil">
              <div>
                <FSvg title="图表" color="#333" hoverColor="#333"></FSvg>
              </div>
              <span>SQL查询数据</span>
            </div>
            <div class="rigCount">
              <div class="rigCount_div">
                <el-table :data="SQLData.tableList" border v-loading="SQLData.load" style="width: 100%;">
                  <el-table-column v-for="item in SQLData.tableProp" :key="item.index" :prop="item.prop" :show-overflow-tooltip="true" align="center" :width="SQLData.tableProp.length>7?'200':'auto'" :label="item.label">
                  </el-table-column>
                </el-table>
                <FBtn type="3" @click="getSaveName(1)">保存</FBtn>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--切换类型-->
      <FDialog class="dataSet_dialog" :dialog="dataSetDialog.show" title="数据接入切换" @close="getDialog(1)" moveWidth="570px">
        <div class="dataSet_dialog_count">
          <div class="type_radio">
            <span :class="{addSpan:dataSetDialog.type===1}" @click="getDialogType(1)">MYSQL</span>
            <span :class="{addSpan:dataSetDialog.type===2}" @click="getDialogType(2)">SQL SERVER</span>
            <span :class="{addSpan:dataSetDialog.type===3}" @click="getDialogType(3)">ORACLE</span>
            <span :class="{addSpan:dataSetDialog.type===0}" @click="getDialogType(0)">EXCEL</span>
            <span :class="{addSpan:dataSetDialog.type===4}" @click="getDialogType(4)">达梦</span>
            <span :class="{addSpan:dataSetDialog.type===5}" @click="getDialogType(5)">金仓</span>
          </div>
          <div class="div_radio">
            <el-radio-group v-model="dataSetDialog.id">
              <el-radio v-for="item in dataSetDialog.typeList" :key="item.index" :label="item.id" v-show="dataSetDialog.type===item.type">
                {{item.dateSourceName}}
              </el-radio>
            </el-radio-group>
          </div>
          <div class="div_btn">
            <FBtn type="1" @click="getDialogReset">重置</FBtn>
            <FBtn type="3" @click="getDialog(2)" :disabled="dataSetDialog.id===dataSet.id">确定</FBtn>
          </div>
        </div>
      </FDialog>
    </div>
    <!-- =====================数据过滤================== -->
    <FDialog class="details_dialog" :dialog="clear.dialog" :title="clear.title" moveWidth="1270px" @close="clearDialog(1)">
      <div class="clear">
        <img class="help" @click="getHelp1(0)" src="../../../../../public/image/help1.png">
        <div class="left" v-show="origData.tableProp.length">
          <div class="field" :class="{active:Active===item}" v-for="item in fieldType" :key="item.index" :label="item.field" @click="clearClass(item)">
            <FSvg title="字符" v-if="item.type===0" color="#13B5B1" IconSize="20"></FSvg>
            <FSvg title="日期" v-if="item.type===1" color="#13B5B1" IconSize="18"></FSvg>
            <FSvg title="数字" v-if="item.type===2" color="#13B5B1" IconSize="20"></FSvg>
            {{item.field}}
          </div>
        </div>
        <div class="left" v-show="!origData.tableProp.length">
          <div class="field_center">暂无数据</div>
          <!-- <div class="field" :class="{active:Active===item}" v-for="item in fieldType" :key="item.index" :label="item.field" @click="clearClass(item)">
            <FSvg title="字符" v-if="item.type===0" color="#13B5B1" IconSize="20"></FSvg>
            <FSvg title="日期" v-if="item.type===1" color="#13B5B1" IconSize="18"></FSvg>
            <FSvg title="数字" v-if="item.type===2" color="#13B5B1" IconSize="20"></FSvg>
            {{item.field}}
          </div> -->
        </div>

        <div class="right">
          <div class="wen">请点击左侧的字段进行数据过滤</div>
          <div v-for='(it,idx) in clearfieldArr' :key='idx' class="judge">
            <input v-if="it.typeInfo ==3||it.typeInfo ==1" id="dataInput1" readonly type="text" maxlength="15" v-model="it.clearText" onkeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" @keyup="it.clearText=checkText(it.clearText)">
            <input v-if="it.typeInfo ==2" id="dataInput2" readonly type="text" maxlength="15" v-model="it.clearText" onkeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" @keyup="it.clearText=checkText(it.clearText)">
            <select id="dataSelect" class="noBorder" placeholder="请选择" v-model="it.dataType" v-if="it.typeInfo ==2" @change="SelectOne1(it)">
              <option v-for="item in timeList" :key="item" :label="item" :value="item">{{item}}</option>
            </select>
            <select id="test" v-model="it.clearSymbol" v-if="it.typeInfo" @change="SelectOne2(it)">
              <option v-for="item in it.strList" :key="item.value" :label="item.label" :value="item">{{item}}</option>
            </select>
            <input class="minInp" type="text" maxlength="15" v-model="it.clearText2" v-if="(it.typeInfo==1||it.typeInfo==3)&&it.clearSymbol!='为空'&&it.clearSymbol!='不为空'" onkeypress="javascript:if(event.keyCode == 32)event.returnValue = false;">
            <span class="big-data">
              <el-date-picker v-if="it.typeInfo ==2&&it.clearSymbol=='区间'&&it.dataType=='年'" value-format="yyyy" format="yyyy" v-model="it.clearText2" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
              <el-date-picker v-if="it.typeInfo ==2&&it.clearSymbol=='区间'&&it.dataType=='月'" value-format="yyyy-MM" format="yyyy-MM" v-model="it.clearText2" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
              <el-date-picker v-if="it.typeInfo ==2&&it.clearSymbol=='区间'&&it.dataType=='日'" value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="it.clearText2" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
              <el-date-picker v-if="it.typeInfo ==2&&it.clearSymbol=='区间'&&it.dataType=='时间'" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" v-model="it.clearText2" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </span>
            <span class="small-data">
              <el-date-picker v-model="it.clearText2" value-format="yyyy" format="yyyy" v-if="it.typeInfo ==2&&it.dataType=='年'&&it.clearSymbol!='区间'&&it.clearSymbol!='为空'&&it.clearSymbol!='不为空'" type="year" placeholder="选择日期时间">
              </el-date-picker>
              <el-date-picker v-model="it.clearText2" value-format="yyyy-MM" format="yyyy-MM" v-if="it.typeInfo ==2&&it.dataType=='月'&&it.clearSymbol!='区间'&&it.clearSymbol!='为空'&&it.clearSymbol!='不为空'" type="month" placeholder="选择日期时间">
              </el-date-picker>
              <el-date-picker v-model="it.clearText2" value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-if="it.typeInfo ==2&&it.dataType=='日'&&it.clearSymbol!='区间'&&it.clearSymbol!='为空'&&it.clearSymbol!='不为空'" type="date" placeholder="选择日期时间">
              </el-date-picker>
              <el-date-picker v-model="it.clearText2" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" v-if="it.dataType=='时间'&&it.clearSymbol&&it.clearSymbol!='区间'&&it.typeInfo&&it.clearSymbol!='为空'&&it.clearSymbol!='不为空'" type="datetime" placeholder="选择日期时间" align="right" :picker-options="pickerOptions">
              </el-date-picker>
            </span>
            <div class="circleBtn">
              <div class="circleAdd" @click="addClearInput()">+</div>
              <div class="circleDel" @click="delClearInput(idx)">-</div>
            </div>
          </div>
        </div>
        <div class="bottom">
          <FBtn type="18" @click="resetting()">重置</FBtn>
          <FBtn type="16" @click="dataFiltering()">确定</FBtn>
          <FBtn type="17" @click="quxiao()">取消</FBtn>
        </div>
      </div>
    </FDialog>
    <!-- =====================数据关联================== -->
    <FDialog class="details_dialog" :dialog="table.dialog" :title="table.title" moveWidth="1200px" @close="tableDialog(1)">
      <div class="table">
        <img class="help" @click="getHelp1(0)" src="../../../../../public/image/help1.png">
        <div class="tit1">数据库表列表</div>
        <div class="tit2">新表名称：<input type="text" maxlength="15" v-model="associationName" onkeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" @keyup="associationName=checkText(associationName)"></div>
        <div style="width: 100%; height: 100%">
          <div class="super-flow-demo1">
            <el-card style="float: left; width: 240px; height: 100%; margin-right: 10px">
              <el-tag style="width: 100%; text-align: center" type="success">请选择并拖拽关联表</el-tag>
              <el-menu default-active="2" class="el-menu-vertical" :default-openeds="openeds" @open="handleOpen" @close="handleClose">
                <el-submenu v-for="(item, index) in parentList" :key="index" :index="item.id + ''">
                  <template slot="title">
                    <!-- <div @click="fortableName()">
                      <i :class="arrow"></i>
                      <span>{{ item.title }}</span>
                    </div> -->
                  </template>
                  <el-menu-item class="node-container" v-for="(citem, cindex) in item.nodeItemList" :key="cindex">
                    <i style="width: 20px; height: 20px; vertical-align:-3px;margin-left:-15px;" class="el-icon-document"></i>
                    <span @mousedown="(evt) => nodeItemMouseDown(evt, citem.value)">{{citem.label.tableName}}</span>
                  </el-menu-item>
                </el-submenu>
              </el-menu>
            </el-card>
            <el-card style="width: calc(100% - 260px); height: 100%; float: right;background-color:#f5f5f5">
              <div style="width: 100%; height: 100%;" ref="flowContainer">
                <super-flow ref="superFlow" :graph-menu="graphMenu" :node-menu="nodeMenu" :link-menu="linkMenu" :link-base-style="linkBaseStyle" :link-style="linkStyle" :link-desc="linkDesc">
                  <template v-slot:node="{ meta }">
                    <div @click="nodeClick" class="flow-node ellipsis">
                      {{ meta.name.tableName }}
                    </div>
                  </template>
                </super-flow>
              </div>
            </el-card>
          </div>
          <!-- 弹窗开始 -->
          <el-dialog class="my-info-dialog" :title="drawerConf.title" :visible.sync="drawerConf.visible" :close-on-click-modal="false" width="500px" :append-to-body='true'>
            <el-form @keyup.native.enter="settingSubmit" @submit.native.prevent v-show="drawerConf.type === drawerType.node" ref="nodeSetting" :model="nodeSetting">
              <el-form-item label="当前表名称" prop="name">
                <el-input v-model="nodeSetting.name.tableName" placeholder="请输入当前表名称" maxlength="30">
                </el-input>
              </el-form-item>
              <el-form-item label="关联字段" prop="desc">
                <el-select v-model="contactTab" placeholder="请输入关联字段">
                  <el-option v-for="item in downTableArr" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>

            <el-form @keyup.native.enter="settingSubmit" @submit.native.prevent v-show="drawerConf.type === drawerType.link" ref="linkSetting" :model="linkSetting">
              <el-form-item :label="this.startTab+'表的关联字段'" prop="desc">
                <el-select v-model="linkSetting.startTabField" placeholder="请输入关联字段">
                  <el-option v-for="item in downTableArr1" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="关联关系" prop="desc">
                <el-select v-model="linkSetting.desc" placeholder="请选择">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.label">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="endTab+'表的关联字段'" prop="desc">
                <el-select v-model="linkSetting.endTabField" placeholder="请输入关联字段">
                  <el-option v-for="item in downTableArr2" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <span class="remarks">
              <el-button @click="drawerConf.cancel"> 取 消 </el-button>
              <el-button type="primary" @click="settingSubmit"> 确 定 </el-button>
            </span>
          </el-dialog>
          <!-- 弹窗结束 -->
          <div class="bottom">
            <!-- <FBtn type="14">预览数据</FBtn> -->
            <FBtn type="12" @click="associationSave">保存</FBtn>
          </div>
        </div>
      </div>
    </FDialog>
    <!-- =====================字段添加================== -->
    <FDialog class="details_dialog" :dialog="add.dialog" :title="add.title" moveWidth="1200px" @close="addDialog(1)">
      <div class="addData">
        <img class="help" @click="getHelp1(0)" src="../../../../../public/image/help1.png">
        <div class="top">
          <div class="fieldName">字段名称：<input type="text" v-model="fieldName" maxlength="20" onkeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" @keyup="fieldName=checkText(fieldName)"></div>
          <div class="addBtn" v-if="delMethods">
            <FBtn v-for="(tab,index) in tabsName" :key="index" @click="tabsSwitch(index,tab)" v-bind="{type:tab.isActive?10:11}">{{tab.name}}</FBtn>
          </div>
        </div>
        <div class="middle">
          <div class="left" v-show="origData.tableProp.length">
            <div class="field" :class="{active:Active===item}" v-for="item in fieldType" :key="item.index" :label="item.field" @click="changeClass(item)">
              <!-- {{item.label}} -->
              <FSvg title="字符" v-if="item.type===0" color="#13B5B1" IconSize="20"></FSvg>
              <FSvg title="日期" v-if="item.type===1" color="#13B5B1" IconSize="18"></FSvg>
              <FSvg title="数字" v-if="item.type===2" color="#13B5B1" IconSize="20"></FSvg>
              {{item.field}}
            </div>
          </div>
          <div class="left" v-show="!origData.tableProp.length">
            <!-- <div class="field_center">暂无数据</div> -->
            <div class="field" :class="{active:Active===item}" v-for="item in fieldType" :key="item.index" :label="item.field" @click="changeClass(item)">
              <!-- {{item}} -->
              <FSvg title="字符" v-if="item.type===0" color="#13B5B1" IconSize="20"></FSvg>
              <FSvg title="日期" v-if="item.type===1" color="#13B5B1" IconSize="18"></FSvg>
              <FSvg title="数字" v-if="item.type===2" color="#13B5B1" IconSize="20"></FSvg>
              {{item.field}}
            </div>
          </div>
          <div class="tab-card" v-show="tabFlag =='算法添加'">
            <div class="center">
              <textarea style="resize: none;" placeholder="请选择您需要使用的算法" v-model="sqlText" class="new" name="" id="" cols="30" rows="10">
              </textarea>
              <!-- <el-button class="by1" :disabled="compileAdd==false" @click="compile()">编译</el-button> -->
              <el-button class="by1" :disabled="!sqlChange" @click="compile()">编译</el-button>
            </div>
            <div class="white"></div>
            <div class="right" v-if="sourceIdType==1">
              <div>
                <h5 id="strLabel" @click="unfoldStr()">字符型支持算法
                  <img id="img1" style="display:inline-block;margin-left:35px" src="../../../../assets/common/logo/right.png">
                  <img id="img2" style="display:none;margin-left:35px" src="../../../../assets/common/logo/bottom.png">
                </h5>
                <h6 id="substr" style="display:none"></h6>
                <ul id="subList" style="display:none">
                  <li v-for="(item,index) in methodsList1" :class="{methodsColor:num===index}" :key="index" @click="methodsColor(index,item)">
                    {{item.title}}
                    <el-tooltip class="item" effect="dark" :content="item.describe" placement="top">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num!==index" src="../../../../assets/common/logo/grayque.png">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num===index" src="../../../../assets/common/logo/blueque.png">
                    </el-tooltip>
                  </li>
                </ul>
              </div>
              <div>
                <h5 id="numLabel" @click="unfoldNum()">数值型支持算法
                  <img id="img3" style="display:inline-block;margin-left:35px" src="../../../../assets/common/logo/right.png">
                  <img id="img4" style="display:none;margin-left:35px" src="../../../../assets/common/logo/bottom.png">
                </h5>
                <h6 id="number" style="display:none"></h6>
                <ul id="numList" style="display:none">
                  <li v-for="(item,index) in methodsList2" :class="{methodsColor:num===index}" :key="index" @click="methodsColor(index,item)">
                    {{item.title}}
                    <el-tooltip class="item" effect="dark" :content="item.describe" placement="top">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num!==index" src="../../../../assets/common/logo/grayque.png">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num===index" src="../../../../assets/common/logo/blueque.png">
                    </el-tooltip>
                  </li>
                </ul>
              </div>
              <div>
                <h5 id="dateLabel" @click="unfoldDate()">时间型支持算法
                  <img id="img5" style="display:inline-block;margin-left:35px" src="../../../../assets/common/logo/right.png">
                  <img id="img6" style="display:none;margin-left:35px" src="../../../../assets/common/logo/bottom.png">
                </h5>
                <h6 id="datetime" style="display:none"></h6>
                <ul id="dateList" style="display:none">
                  <li v-for="(item,index) in methodsList3" :class="{methodsColor:num===index}" :key="index" @click="methodsColor(index,item)">
                    {{item.title}}
                    <el-tooltip class="item" effect="dark" :content="item.describe" placement="top">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num!==index" src="../../../../assets/common/logo/grayque.png">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num===index" src="../../../../assets/common/logo/blueque.png">
                    </el-tooltip>
                  </li>
                </ul>
              </div>
            </div>

            <div class="right" v-if="sourceIdType==2">
              <div>
                <h5 id="strLabel" @click="unfoldStr()">字符型支持算法
                  <img id="img1" style="display:inline-block;margin-left:35px" src="../../../../assets/common/logo/right.png">
                  <img id="img2" style="display:none;margin-left:35px" src="../../../../assets/common/logo/bottom.png">
                </h5>
                <h6 id="substr" style="display:none"></h6>
                <ul id="subList" style="display:none">
                  <li v-for="(item,index) in sqlMethodsList1" :class="{methodsColor:num===index}" :key="index" @click="methodsColor(index,item)">
                    {{item.title}}
                    <el-tooltip class="item" effect="dark" :content="item.describe" placement="top">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num!==index" src="../../../../assets/common/logo/grayque.png">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num===index" src="../../../../assets/common/logo/blueque.png">
                    </el-tooltip>
                  </li>
                </ul>
              </div>
              <div>
                <h5 id="numLabel" @click="unfoldNum()">数值型支持算法
                  <img id="img3" style="display:inline-block;margin-left:35px" src="../../../../assets/common/logo/right.png">
                  <img id="img4" style="display:none;margin-left:35px" src="../../../../assets/common/logo/bottom.png">
                </h5>
                <h6 id="number" style="display:none"></h6>
                <ul id="numList" style="display:none">
                  <li v-for="(item,index) in sqlMethodsList2" :class="{methodsColor:num===index}" :key="index" @click="methodsColor(index,item)">
                    {{item.title}}
                    <el-tooltip class="item" effect="dark" :content="item.describe" placement="top">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num!==index" src="../../../../assets/common/logo/grayque.png">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num===index" src="../../../../assets/common/logo/blueque.png">
                    </el-tooltip>
                  </li>
                </ul>
              </div>
              <div>
                <h5 id="dateLabel" @click="unfoldDate()">时间型支持算法
                  <img id="img5" style="display:inline-block;margin-left:35px" src="../../../../assets/common/logo/right.png">
                  <img id="img6" style="display:none;margin-left:35px" src="../../../../assets/common/logo/bottom.png">
                </h5>
                <h6 id="datetime" style="display:none"></h6>
                <ul id="dateList" style="display:none">
                  <li v-for="(item,index) in sqlMethodsList3" :class="{methodsColor:num===index}" :key="index" @click="methodsColor(index,item)">
                    {{item.title}}
                    <el-tooltip class="item" effect="dark" :content="item.describe" placement="top">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num!==index" src="../../../../assets/common/logo/grayque.png">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num===index" src="../../../../assets/common/logo/blueque.png">
                    </el-tooltip>
                  </li>
                </ul>
              </div>
            </div>
            <div class="right" v-if="sourceIdType==3">
              <div>
                <h5 id="strLabel" @click="unfoldStr()">字符型支持算法
                  <img id="img1" style="display:inline-block;margin-left:35px" src="../../../../assets/common/logo/right.png">
                  <img id="img2" style="display:none;margin-left:35px" src="../../../../assets/common/logo/bottom.png">
                </h5>
                <h6 id="substr" style="display:none"></h6>
                <ul id="subList" style="display:none">
                  <li v-for="(item,index) in oracleMethodsList1" :class="{methodsColor:num===index}" :key="index" @click="methodsColor(index,item)">
                    {{item.title}}
                    <el-tooltip class="item" effect="dark" :content="item.describe" placement="top">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num!==index" src="../../../../assets/common/logo/grayque.png">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num===index" src="../../../../assets/common/logo/blueque.png">
                    </el-tooltip>
                  </li>
                </ul>
              </div>
              <div>
                <h5 id="numLabel" @click="unfoldNum()">数值型支持算法
                  <img id="img3" style="display:inline-block;margin-left:35px" src="../../../../assets/common/logo/right.png">
                  <img id="img4" style="display:none;margin-left:35px" src="../../../../assets/common/logo/bottom.png">
                </h5>
                <h6 id="number" style="display:none"></h6>
                <ul id="numList" style="display:none">
                  <li v-for="(item,index) in oracleMethodsList2" :class="{methodsColor:num===index}" :key="index" @click="methodsColor(index,item)">
                    {{item.title}}
                    <el-tooltip class="item" effect="dark" :content="item.describe" placement="top">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num!==index" src="../../../../assets/common/logo/grayque.png">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num===index" src="../../../../assets/common/logo/blueque.png">
                    </el-tooltip>
                  </li>
                </ul>
              </div>
              <div>
                <h5 id="dateLabel" @click="unfoldDate()">时间型支持算法
                  <img id="img5" style="display:inline-block;margin-left:35px" src="../../../../assets/common/logo/right.png">
                  <img id="img6" style="display:none;margin-left:35px" src="../../../../assets/common/logo/bottom.png">
                </h5>
                <h6 id="datetime" style="display:none"></h6>
                <ul id="dateList" style="display:none">
                  <li v-for="(item,index) in oracleMethodsList3" :class="{methodsColor:num===index}" :key="index" @click="methodsColor(index,item)">
                    {{item.title}}
                    <el-tooltip class="item" effect="dark" :content="item.describe" placement="top">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num!==index" src="../../../../assets/common/logo/grayque.png">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num===index" src="../../../../assets/common/logo/blueque.png">
                    </el-tooltip>
                  </li>
                </ul>
              </div>
            </div>
            <div class="right" v-if="sourceIdType==4">
              <div>
                <h5 id="strLabel" @click="unfoldStr()">字符型支持算法
                  <img id="img1" style="display:inline-block;margin-left:35px" src="../../../../assets/common/logo/right.png">
                  <img id="img2" style="display:none;margin-left:35px" src="../../../../assets/common/logo/bottom.png">
                </h5>
                <h6 id="substr" style="display:none"></h6>
                <ul id="subList" style="display:none">
                  <li v-for="(item,index) in DaMengMethodsList1" :class="{methodsColor:num===index}" :key="index" @click="methodsColor(index,item)">
                    {{item.title}}
                    <el-tooltip class="item" effect="dark" :content="item.describe" placement="top">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num!==index" src="../../../../assets/common/logo/grayque.png">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num===index" src="../../../../assets/common/logo/blueque.png">
                    </el-tooltip>
                  </li>
                </ul>
              </div>
              <div>
                <h5 id="numLabel" @click="unfoldNum()">数值型支持算法
                  <img id="img3" style="display:inline-block;margin-left:35px" src="../../../../assets/common/logo/right.png">
                  <img id="img4" style="display:none;margin-left:35px" src="../../../../assets/common/logo/bottom.png">
                </h5>
                <h6 id="number" style="display:none"></h6>
                <ul id="numList" style="display:none">
                  <li v-for="(item,index) in DaMengMethodsList2" :class="{methodsColor:num===index}" :key="index" @click="methodsColor(index,item)">
                    {{item.title}}
                    <el-tooltip class="item" effect="dark" :content="item.describe" placement="top">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num!==index" src="../../../../assets/common/logo/grayque.png">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num===index" src="../../../../assets/common/logo/blueque.png">
                    </el-tooltip>
                  </li>
                </ul>
              </div>
              <div>
                <h5 id="dateLabel" @click="unfoldDate()">时间型支持算法
                  <img id="img5" style="display:inline-block;margin-left:35px" src="../../../../assets/common/logo/right.png">
                  <img id="img6" style="display:none;margin-left:35px" src="../../../../assets/common/logo/bottom.png">
                </h5>
                <h6 id="datetime" style="display:none"></h6>
                <ul id="dateList" style="display:none">
                  <li v-for="(item,index) in DaMengMethodsList3" :class="{methodsColor:num===index}" :key="index" @click="methodsColor(index,item)">
                    {{item.title}}
                    <el-tooltip class="item" effect="dark" :content="item.describe" placement="top">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num!==index" src="../../../../assets/common/logo/grayque.png">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num===index" src="../../../../assets/common/logo/blueque.png">
                    </el-tooltip>
                  </li>
                </ul>
              </div>
            </div>
            <div class="right" v-if="sourceIdType==5">
              <div>
                <h5 id="strLabel" @click="unfoldStr()">字符型支持算法
                  <img id="img1" style="display:inline-block;margin-left:35px" src="../../../../assets/common/logo/right.png">
                  <img id="img2" style="display:none;margin-left:35px" src="../../../../assets/common/logo/bottom.png">
                </h5>
                <h6 id="substr" style="display:none"></h6>
                <ul id="subList" style="display:none">
                  <li v-for="(item,index) in KingBaseMethodsList1" :class="{methodsColor:num===index}" :key="index" @click="methodsColor(index,item)">
                    {{item.title}}
                    <el-tooltip class="item" effect="dark" :content="item.describe" placement="top">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num!==index" src="../../../../assets/common/logo/grayque.png">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num===index" src="../../../../assets/common/logo/blueque.png">
                    </el-tooltip>
                  </li>
                </ul>
              </div>
              <div>
                <h5 id="numLabel" @click="unfoldNum()">数值型支持算法
                  <img id="img3" style="display:inline-block;margin-left:35px" src="../../../../assets/common/logo/right.png">
                  <img id="img4" style="display:none;margin-left:35px" src="../../../../assets/common/logo/bottom.png">
                </h5>
                <h6 id="number" style="display:none"></h6>
                <ul id="numList" style="display:none">
                  <li v-for="(item,index) in KingBaseMethodsList2" :class="{methodsColor:num===index}" :key="index" @click="methodsColor(index,item)">
                    {{item.title}}
                    <el-tooltip class="item" effect="dark" :content="item.describe" placement="top">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num!==index" src="../../../../assets/common/logo/grayque.png">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num===index" src="../../../../assets/common/logo/blueque.png">
                    </el-tooltip>
                  </li>
                </ul>
              </div>
              <div>
                <h5 id="dateLabel" @click="unfoldDate()">时间型支持算法
                  <img id="img5" style="display:inline-block;margin-left:35px" src="../../../../assets/common/logo/right.png">
                  <img id="img6" style="display:none;margin-left:35px" src="../../../../assets/common/logo/bottom.png">
                </h5>
                <h6 id="datetime" style="display:none"></h6>
                <ul id="dateList" style="display:none">
                  <li v-for="(item,index) in KingBaseMethodsList3" :class="{methodsColor:num===index}" :key="index" @click="methodsColor(index,item)">
                    {{item.title}}
                    <el-tooltip class="item" effect="dark" :content="item.describe" placement="top">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num!==index" src="../../../../assets/common/logo/grayque.png">
                      <img :key="index" style="position:absolute;right:10px;top:7px" v-if="num===index" src="../../../../assets/common/logo/blueque.png">
                    </el-tooltip>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="tab-card" v-show="tabFlag !='算法添加'">
            <div class="new">添加新字段的计算方式</div>
            <div class="conditions" id="inputDiv">
              <div v-for='(it,idx) in fieldArr' :key='idx' class="judge">
                <span>当</span>
                <input type="text" maxlength="15" v-model="it.fieldText" onkeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" @keyup="it.fieldText=checkText(it.fieldText)">
                <select id="test" v-model="it.celect" :class="{null:it.celect=='为空'||it.celect=='不为空'}">
                  <option v-for="item in timeout" :key="item.value" :label="item.label" :value="item">{{item}}</option>
                </select>
                <input type="text" maxlength="15" v-model="it.fieldText2" v-if="it.celect!='为空'&&it.celect!='不为空'" onkeypress="javascript:if(event.keyCode == 32)event.returnValue = false;">
                <span>时，字段值为</span>
                <input type="text" maxlength="15" v-model="it.fieldText3" onkeypress="javascript:if(event.keyCode == 32)event.returnValue = false;">
                <div class="circleBtn">
                  <div class="circleAdd" @click="addInput()">+</div>
                  <div class="circleDel" @click="decInput(idx)">-</div>
                </div>
              </div>
            </div>
            <div class="end">否则，字段值为
              <input type="text" maxlength="15" v-model="otherwise" onkeypress="javascript:if(event.keyCode == 32)event.returnValue = false;">
            </div>
            <!-- <FBtn type="12" @click="condition()">编译</FBtn> -->
            <el-button class="by1" :disabled="!conditionChange" @click="condition()">编译</el-button>
          </div>
        </div>
        <div class="bottom">
          <div class="blank"></div>
          <div class="label">
            <!-- <span class="error">计算公式有误，无法生成数据</span> -->
          </div>
          <div class="save_cancel">
            <el-button :class="[addBtn?'addBtnT':'addBtnF']" :disabled="!addBtn" @click="saveField()" v-if="delMethods">添加</el-button>
            <FBtn type="14" @click="changeField()" v-if="!delMethods">修改</FBtn>
            <FBtn type="14" @click="quxiao()">取消</FBtn>
          </div>
        </div>
      </div>
    </FDialog>
    <!-- =====================移除字段================== -->
    <FDialog class="details_dialog" :dialog="del.dialog" :title="del.title" moveWidth="730px" @close="delDialog(1)">
      <div class="del">
        <img class="help" @click="getHelp1(0)" src="../../../../../public/image/help1.png">
        <div class="del_left">
          <div class="tit">可删除字段<img src="../../../../assets/common/image/check.png"></div>
          <div class="content">
            <div class="field" v-show="origData.tableProp.length" :class="{active:Active===item}" v-for="item in origData.tableProp" :label="item.label" @click="delchangeClass(item)">
              <label style="display:inline-block;width:250;pxwhite-space: nowrap;text-overflow: ellipsis;overflow: hidden;word-break: break-all;"><input id="check" type="checkbox" :value="item.label" name="check" @click="choose()">{{item.label}}</label>
            </div>
            <!-- <div class="field_center" v-show="!origData.tableProp.length">暂无数据</div> -->
            <div class="field" v-show="!origData.tableProp.length" :class="{active:Active===item}" v-for="item in getFieldsInfo" :label="item" @click="delchangeClass(item)">
              <label style="display:inline-block;width:250;pxwhite-space: nowrap;text-overflow: ellipsis;overflow: hidden;word-break: break-all;"><input id="check" type="checkbox" :value="item" name="check" @click="choose()">{{item}}</label>
            </div>
          </div>
        </div>
        <el-tooltip class="item" effect="dark" content="删除" placement="top">
          <div class="jian1" @click="delDetermine()"></div>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="恢复" placement="bottom">
          <div class="jian2" @click="recoveryField()"></div>
        </el-tooltip>
        <div class="del_right">
          <div class="tit">已删除字段<img src="../../../../assets/common/image/delect.png"></div>
          <div class="content">
            <div class="field" v-show="origData.tableProp.length" :class="{active:Active===item}" v-for="(item,index) in arrDelList" :label="item.label" @click="delchangeClass(item)">
              <label style="display:inline-block;width:250;pxwhite-space: nowrap;text-overflow: ellipsis;overflow: hidden;word-break: break-all;"><input id="check2" type="checkbox" :value="item" name="check2" @click="choose2()">{{item}}</label>
            </div>
            <!-- <div class="field_center" v-show="!origData.tableProp.length">
              暂无数据
            </div> -->
            <div class="field" v-show="!origData.tableProp.length" :class="{active:Active===item}" v-for="(item,index) in arrDelList" :label="item.label" @click="delchangeClass(item)">
              <label style="display:inline-block;width:250;pxwhite-space: nowrap;text-overflow: ellipsis;overflow: hidden;word-break: break-all;"><input id="check2" type="checkbox" :value="item" name="check2" @click="choose2()">{{item}}</label>
            </div>
          </div>
        </div>
      </div>
    </FDialog>
    <!-- 数据关联中的预览数据弹窗 -->
    <FDialog class="details_dialog" :dialog="circle.dialog" title="预览数据" moveWidth="1660px" @close="circleDialog(1)">
      <div class="rigS_table" id="dataSource_table">
        <el-table :data="tableData.list" style="width: 100%;">
          <!-- <el-table-column type="selection" align="center" class-name="checkCom" width="55">
               </el-table-column> -->
          <el-table-column prop="dateSourceName" :show-overflow-tooltip="true" align="center" label="序号" width="110" class-name="checkFirstTab">
          </el-table-column>
          <el-table-column prop="dateSourceName" :show-overflow-tooltip="true" align="center" label="字段" class-name="checkFirstTab">
          </el-table-column>
          <el-table-column prop="dateSourceName" :show-overflow-tooltip="true" align="center" label="默认值" class-name="checkFirstTab">
          </el-table-column>

          <el-table-column prop="dateSourceName" :show-overflow-tooltip="true" align="center" label="数据类型" class-name="checkFirstTab">
          </el-table-column>

          <el-table-column prop="createTime" align="center" :show-overflow-tooltip="true" label="是否为空">
          </el-table-column>
          <el-table-column prop="address" align="center" :show-overflow-tooltip="true" class-name="table_xq" label="主键">
            <template slot-scope="scope">
              <div class="xqSpan" @click="detailsDialog(0,scope.row)">
                <span>详情参数</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="address" align="center" width="200" :show-overflow-tooltip="true" class-name="table_route" label="说明">
            <template slot-scope="scope">
              <div class="routeDiv">
                <FSvg title="下一步" @click.native="getRoutePush(scope.row)"></FSvg>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <FPage :pageSize="tableData.pageSize" :total="tableData.total" @page="getPage"></FPage>
      </div>
    </FDialog>
    <FDialog class="details_dialog" :dialog="help.dialog" :title="help.title" moveWidth="610px" @close="getHelp1(1)">
      <div class="help1" v-if="this.helpPage ==1 ">
        <!-- <img src="../../../public/image/help2/1.jpg"> -->
        <img src="../../../../../public/image/help2/2.jpg">
        <span>如图所示图标：str代表字符型,井号代表数值型,日历代表时间型；</span>
        <span>选择任意一个字段进行筛选</span>
        <img src="../../../../../public/image/help2/3.jpg">
        <span>选择筛选条件→输入筛选结果→确定</span>
      </div>

      <div class="help1" v-if="this.helpPage ==2 ">
        <img src="../../../../../public/image/help2/4.jpg">
        <span>拖拽左侧列表的的表名</span>
        <img src="../../../../../public/image/help2/5.jpg">
        <span>矩形边缘拖拽出关联线</span>
        <img src="../../../../../public/image/help2/6.jpg">
        <span>右键关联线进行关联关系信息编辑→确定→顶部输入关联表的名称→保存</span>
      </div>

      <div class="help1" v-if="this.helpPage ==3 ">
        <span>算法添加：</span>
        <img src="../../../../../public/image/help2/7.jpg">
        <span>右侧选择算法类型→左侧选择对应类型字段→编译→编译成功→输入字段名称→添加</span>
        <span>条件添加：</span>
        <img src="../../../../../public/image/help2/8.jpg">
        <span>选择左侧字段→完善右侧条件信息→编译→输入字段名称→添加</span>
      </div>
      <div class="help1" v-if="this.helpPage ==4 ">
        <img src="../../../../../public/image/help2/9.jpg">
        <span>勾选左侧需删除的字段→点击向右的箭头</span>
        <img src="../../../../../public/image/help2/10.jpg">
        <span>勾选右侧需恢复的字段→点击向左的箭头</span>
      </div>
    </FDialog>
    <FDialog class="details_dialog" :dialog="change.dialog" :title="change.title" moveWidth="1140px" @close="changeDialog(1)">
      <div class="changeBox">
        <div class="changeLeft" v-show="origData.tableProp.length">
          <div class="field" :class="{active:Active===item}" v-for="item in fieldType" :key="item.index" :label="item.field" @click="changeType(item)">
            <!-- {{item.label}} -->
            <FSvg title="字符" v-if="item.type===0" color="#13B5B1" IconSize="20"></FSvg>
            <FSvg title="日期" v-if="item.type===1" color="#13B5B1" IconSize="18"></FSvg>
            <FSvg title="数字" v-if="item.type===2" color="#13B5B1" IconSize="20"></FSvg>
            {{item.field}}
          </div>
        </div>
        <div class="tab-card2">
          <div class="new">选择左侧字段修改其字段类型</div>
          <div class="conditions" id="inputDiv">
            <div v-for='(it,idx) in changeArr' :key='idx' class="judge">
              <span>将</span>
              <input class="input2" type="text" maxlength="15" v-model="it.fieldText" onkeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" @keyup="it.fieldText=checkText(it.fieldText)">
              <span>字段转换为</span>
              <select class="select2" id="test" v-model="it.celect">
                <option v-for="item in changeCondition" :key="item.value" :label="item.label" :value="item">{{item}}</option>
              </select>
              <span>类型</span>
              <div class="circleBtn">
                <div class="circleAdd" @click="changeAddInput()">+</div>
                <div class="circleDel" @click="changeDelInput(idx)">-</div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottomBox">
          <div v-if="changeTypeNum" class="changeTypeBtn2" @click="resetTypeSave()">重置</div>
          <div class="changeTypeBtn" @click="changTypeSave()">保存</div>
        </div>
      </div>
    </FDialog>
  </div>
</template>



<script>
/**
 @author xiaoye
 @date 2020/4/7 2:53 下午
 */
import {
  GetDataSourceList,
  GetConnByDataSource,
  GetTableNameBySourceID,
  GetSqlListByUser,
  GetInfoBySql,
  GetInfoByTableName,
  GetDataSetList,
  RemoveDataSet,
  SaveDataSet,
  GetDataSetNameVerify,
  AddField,
  SaveTable,
  DelField,
  AddCaseWhen,
  JoinTables,
  GetFieldCount,
  GetFieldinfo,
  UpdateFuns,
  UpdateCase,
  CreateFilter,
  GetDelFieldsInfo,
  GetFilterInfo,
  GetFieldsInfo,
  GetFieldsInfo2,
  RestoreField,
  DelTableJoin,
  UpTypes,
  GetFieldsDele,
  GetFields
} from '@/assets/axios/dataUpload/dataSet'
import * as CodeMirror from 'codemirror/lib/codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/sql/sql';
import 'codemirror/theme/eclipse.css';
import vLeftSource from '../../../../components/LeftSource/LeftSource.vue'
import FDialog from '../../../../components/FDialog/FDialog.vue';
import Mirror from '../../../../components/CodeMirror/Codemirror.vue';
import '@/assets/common/icon/iconfont.css'
import {
  MySqlConnText,
  SqlServerConnText,
  OraConnText,
  ExcelConnTestAsync,
  SaveDataSource,
  GetDataSourceTableList,
  GetDataSourceByDataSourceId,
  RemoveDataSource,
  GetDataSourceNameVerify,
  DaMengConnText,
  KingBaseConnText
} from '@/assets/axios/dataUpload/dataSource'
import SuperFlow from 'vue-super-flow'
import 'vue-super-flow/lib/index.css'
import { rad2deg } from '../../../../components/FCharsDrog/helper';

const drawerType = {
  node: 0,
  link: 1,
};
export default {
  inject: ['reload'],//使用inject注入reload变量
  name: 'dataSet',
  components: {
    vLeftSource,
    FDialog,
    Mirror,
    SuperFlow,//数据关联
  },
  props: {},
  data() {
    return {
      changeTypeNum: true,
      help: {
        dialog: false,
        title: '帮助',
        type: 0,
      },
      helpPage: 0,
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      value2: '',
      timeSection: [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)],
      dataType: "年",
      timeList: ['年', '月', '日', '时间'],
      fieldType: [],
      conditionChange: "",
      sqlChange: true,
      addBtn: "",
      getFieldsInfo: [],
      compileAdd: true,
      delMethods: true,
      sourceIdType: "",
      contactTab: "",
      downTableArr1: [],
      downTableArr2: [],
      startTabField: "",
      endTabField: "",
      startTab: "",
      endTab: "",
      tableAssociationListLength: "0",
      tableAssociationList: "",
      c: "",
      arrDelList: [],
      arrHF: [],
      downTableArr: [],
      options: [{
        value: '选项1',
        label: '左关联'
      }, {
        value: '选项2',
        label: '右关联'
      }, {
        value: '选项3',
        label: '内关联'
      }, {
        value: '选项4',
        label: '全关联'
      }],
      value: '',
      openeds: ['1'],
      uniqueOpened: false,
      alreadyScreen: "",//查询数据过滤数量
      alreadyTable: [],
      alreadyDel: "",//查询已删除字段数量
      arrList: [],
      fieldInfo: '',//新增的算法添加的语句
      fieldAlias: '',//新增的算法添加的字段名字
      fieldCaseAlias: '',//新增的条件添加的字段名字
      fieldCaseElse: '',//新增的条件添加的字段名字
      fieldCaseFields: [],//新增条件添加，中间的条件过程
      addName: [],
      addNum: '',
      associationName: '',//关联关系新表名称
      alltabName: [],
      objtabName: [],
      otherwise: '',//条件数据扩充 否则返回值
      fieldName: '',
      arr1: [],//选中待删除的字段
      arr2: [],//已经删除成功的字段
      tableData: {
        list: [],
        pageIndex: 1,
        pageSize: 10,
        total: 10,
        load: true
      },
      dropWDS: {
        label: '',
      },
      dropDIFF: {
        title: '',
      },
      dropCIRCLE: {
        table: '',
      },
      NeedList1: [],
      NeedList2: [],
      NeedList3: [],
      num: 0,
      Active: 0,
      tabsName: [{
        name: "算法添加",
        isActive: true,
      }, {
        name: "条件添加",
        isActive: false
      },],
      active: false,
      //页面刷新
      allLoad: false,
      //数据准备类型
      dataSetType: 0,
      //数据准备
      dataSet: {
        //选中的数据接入id
        id: '',
        load: true,
        //选中的数据接入信息
        activeType: {},
        origList: [],
        SQLList: []
      },
      //选中的数据
      activeDataSet: {
        orig: 0,
        SQL: -1
      },
      //数据准备列表
      dataSetBom: {
        load: true,
        list: []
      },
      //原有表数据
      origData: {
        til: '',
        load: true,
        tableList: [],
        tableProp: []
      },
      // SQL 数据
      SQLData: {
        load: false,
        text: '',
        tableList: [],
        tableProp: []
      },
      // SQL 代码编辑器
      SQLText: null,
      //弹框切换类型
      dataSetDialog: {
        id: '',
        show: false,
        type: 1,
        typeList: [],
      },
      clear: {
        dialog: false,
        title: '数据过滤',
        type: 0,
      },
      table: {
        dialog: false,
        title: '数据关联',
        type: 0,
      },
      add: {
        dialog: false,
        title: '数据扩充',
        type: 0,
      },
      del: {
        dialog: false,
        title: '删除字段',
        type: 0,
      },
      circle: {
        dialog: false,
        title: '删除字段',
        type: 0,
      },
      change: {
        dialog: false,
        title: '格式转换',
      },
      methodsList1: [
        {
          num: 1,
          title: "字符串拼接",
          sqlText: "CONCAT(字段名称,'拼接内容')",
          describe: "CONCAT(字段名称,'字段或者拼接内容',....)方法可添加多个用于拼接的内容",
        },
        {
          num: 2,
          title: "字符串截取",
          sqlText: "SUBSTR(字段名称,LENGTH(字段名称) - 5)",
          describe: "SUBSTR(字段名称,开始截取的位置)",
        },
        {
          num: 3,
          title: "大写变小写",
          sqlText: "LCASE(字段名称)",
          describe: "LCASE(字段名称)",
        },
        {
          num: 4,
          title: "小写变大写",
          sqlText: "UCASE(字段名称)",
          describe: "UCASE(字段名称)",
        },
        {
          num: 5,
          title: "替换",
          sqlText: "REPLACE(字段名称,'a','x')",
          describe: "REPLACE(字段名称,a,x)将该字符串中的x替代该字符串中的a",
        },
        {
          num: 6,
          title: "LEET()",
          sqlText: "LEFT(字段名称,2)",
          describeL: "LEFT(字段名称,n)返回(截取)该字符串的前 n 个字符"
        },
        {
          num: 7,
          title: "LTRIM()",
          sqlText: "LTRIM(字段名称)",
          describe: "LTRIM(字段名称)去掉该字符串开始处的空格"
        },
        {
          num: 8,
          title: "RTRIM()",
          sqlText: "RTRIM(字段名称)",
          describe: "RTRIM(字段名称)去掉该字符串结尾处的空格",
        },
        {
          num: 9,
          title: "CAST()",
          sqlText: "CAST(字段名称 AS DATE);",
          describe: "CAST(字段名称 AS DATE) 转换数据类型",
        },
      ],
      methodsList2: [
        {
          num: 1,
          title: "+",
          sqlText: "字段名称 + 1",
          describe: "该字段的数值 + 1",
        },
        {
          num: 2,
          title: "-",
          sqlText: "字段名称 - 1",
          describe: "该字段的数值 - 1",
        },
        {
          num: 3,
          title: "*",
          sqlText: "字段名称 * 2",
          describe: "该字段的数值 * 2",
        },
        {
          num: 4,
          title: "/",
          sqlText: "字段名称 / 2",
          describe: "该字段的数值 / 2",
        },
        {
          num: 5,
          title: "取n次方",
          sqlText: "POW(字段名称,2)",
          describe: "该字段的数值取n次方",
        },
        {
          num: 6,
          title: "取开n次方",
          sqlText: "SQRT(POW(字段名称,2))",
          describe: "该字段的数值取开n次方",

        },
      ],
      methodsList3: [
        {
          num: 1,
          title: "获取当前时间",
          sqlText: "CURRENT_TIME()",
          describe: "获取当前时间",
        },
        {
          num: 2,
          title: "当前时间转时间戳",
          sqlText: "UNIX_TIMESTAMP(CURRENT_TIME())",
          describe: "当前时间转时间戳",
        },
        {
          num: 3,
          title: "时间戳转日期",
          sqlText: "FROM_UNIXTIME(UNIX_TIMESTAMP(字段名称))",
          describe: "时间戳转日期",
        },
        {
          num: 4,
          title: "获取时间间隔",
          sqlText: "DATEDIFF(CURRENT_TIMESTAMP(),字段名称)",
          describe: "获取当前时间和目标时间的时间间隔",
        },
        {
          num: 5,
          title: "日期加减",
          sqlText: "DATE_ADD(字段名称,INTERVAL 10 DAY)",
          describe: "type的值可以为:YEAR(年)、MONTH(月)、DAY(日)、HOUR(时)、MINUTE(分)、SECOND(秒)",
        },
        {
          num: 6,
          title: "日期格式截取",
          sqlText: "DATE_FORMAT(字段名称,%Y-%m-%d %H:%i:%s)",
          describe: "type的值可以为:%Y(4位年份)、%y(2位年份)、%m(月份补0)、%c(月份不补0)、%d(天数补0)、%e(天数不补0)、%H(24制小时补0)、%k(24制小时不补0)、%h(12制小时补0)、%I(12制小时不补0)、%i(分钟补0)、%r(12小时hh:mm:ss AM/PM)、%T(24小时hh:mm:ss)、%S(秒数补0)、%s(秒数不补0)",
        },
        {
          num: 7,
          title: "获取当前年份",
          sqlText: "YEAR(NOW())",
          describe: "获取当前年份，不可操作",
        },
        {
          num: 8,
          title: "获取当前月份",
          sqlText: "MONTH(NOW())",
          describe: "获取当前月份，不可操作",
        },
        {
          num: 9,
          title: "获取当前天数",
          sqlText: "DAY(NOW())",
          describe: "获取当前天数，不可操作",
        },
        {
          num: 10,
          title: "获取当前小时",
          sqlText: "HOUR(NOW())",
          describe: "获取当前小时，不可操作",
        },
        {
          num: 11,
          title: "获取当前分钟",
          sqlText: "MINUTE(NOW())",
          describe: "获取当前分钟，不可操作",
        },
        {
          num: 12,
          title: "获取当前秒数",
          sqlText: "SECOND(NOW())",
          describe: "获取当前秒数，不可操作",
        },
        {
          num: 13,
          title: "日期减具体时间",
          sqlText: "DATE_SUB(字段名称,INTERVAL 3 YEAR)",
          describe: "type的值可以为:YEAR(年)、MONTH(月)、DAY(日)、HOUR(时)、MINUTE(分)、SECOND(秒);例如：DATE_SUB(NOW(),INTERVAL '2:26' HOUR_MINUTE)减2时26分、DATE_SUB(NOW(),INTERVAL '3_2' YEAR_MONTH)减3年2个月",
        },

      ],

      sqlMethodsList1: [
        {
          num: 1,
          title: "字符串截取",
          sqlText: "SUBSTRING(字段名称,1,2)",
          describe: "SUBSTRING(字段名称,从第n个字符后开始截取,截取n个) 汉字、数字、英文占一个字符",
        },
        {
          num: 2,
          title: "字符串拼接",
          sqlText: "CONCAT(字段名称,'拼接内容')",
          describe: "CONCAT(字段名称,拼接内容,....)方法可添加多个用于拼接的内容 至少两个参数",
        },
        {
          num: 3,
          title: "大写变小写",
          sqlText: "LOWER(字段名称)",
          describe: "LOWER(字段名称)字符串大写变小写",
        },
        {
          num: 4,
          title: "小写变大写",
          sqlText: "UPPER(字段名称)",
          describe: "UPPER(字段名称)字符串小写变大写",
        },
        {
          num: 5,
          title: "替换",
          sqlText: "REPLACE(字段名称,'a','x')",
          describe: "REPLACE(字段名称,a,x)将该字符串中的x替代该字符串中的a",
        },
        {
          num: 6,
          title: "LEFT()",
          sqlText: "LEFT(字段名称,2)",
          describe: "LEFT(字段名称,n)截取该字符串的前 n 个字符",
        },
        {
          num: 7,
          title: "LTRIM()",
          sqlText: "LTRIM(字段名称)",
          describe: "LTRIM(字段名称)去掉该字符串开始处的空格",
        },
        {
          num: 8,
          title: "RTRIM()",
          sqlText: "RTRIM(字段名称)",
          describe: "RTRIM(字段名称)去掉该字符串结尾处的空格",
        },
        {
          num: 9,
          title: "CAST()",
          sqlText: "CAST(字段名称 AS DATE)",
          describe: "CAST(字段名称 AS DATE) 转换数据类型",
        },
      ],
      sqlMethodsList2: [
        {
          num: 1,
          title: "+",
          sqlText: "字段名称 + 1",
          describe: "该字段的数值 + 1",
        },
        {
          num: 2,
          title: "-",
          sqlText: "字段名称 - 1",
          describe: "该字段的数值 - 1",
        },
        {
          num: 3,
          title: "*",
          sqlText: "字段名称 * 2",
          describe: "该字段的数值 * 2",
        },
        {
          num: 4,
          title: "/",
          sqlText: "字段名称 / 2",
          describe: "该字段的数值 / 2",
        },
        {
          num: 5,
          title: "取2次方根",
          sqlText: "SQRT(字段名称)",
          describe: "该字段的数值取2次方方根",
        },
        {
          num: 6,
          title: "取n次方根",
          sqlText: "SQRT(POWER(字段名称,2))",
          describe: "该字段的数值取开n次方",

        },
      ],
      sqlMethodsList3: [
        {
          num: 1,
          title: "获取当前时间",
          sqlText: "GETDATE()",
          describe: "获取当前时间",
        },
        {
          num: 2,
          title: "时间转换成时间戳",
          sqlText: "DATEDIFF(s,1970-01-01 08:00:00,字段名称",
          describe: "DATEDIFF(s,1970-01-01 08:00:00,字段名称)",
        },
        {
          num: 3,
          title: "时间间隔",
          sqlText: "DATEDIFF(DD,2021-12-01 08:00:00,字段名称",
          describe: "DATEDIFF(DD,字段1,字段2)",
        },
        {
          num: 4,
          title: "日期加减",
          sqlText: "DATEADD(dd,3,字段名称)",
          describe: "常用的值有：年(yy/yyyy),季度(qq/q),月份(mm/m),日(day/dd/d),周(wk/ww),小时(hh),分钟(mi,n),秒(ss/s)",
        },
        {
          num: 5,
          title: "日期格式转化",
          sqlText: "DATEPART(year, 字段名称)",
          describe: "type的值可以为:year(年)、month(月)、day(日)、week(周数)、weekday(星期)、hour(时)、Minute(分)、Second(秒)",
        },
        {
          num: 6,
          title: "获取当前年份",
          sqlText: "YEAR(GETDATE())",
          describe: "获取当前年份，不可操作",
        },
        {
          num: 7,
          title: "获取当前月份",
          sqlText: "MONTH(GETDATE())",
          describe: "获取当前月份，不可操作",
        },
        {
          num: 8,
          title: "获取当前天数",
          sqlText: "DAY(GETDATE())",
          describe: "获取当前天数，不可操作",
        },
      ],


      oracleMethodsList1: [
        {
          num: 1,
          title: "字符串截取",
          sqlText: "SUBSTRING(字段名称,1,2)",
          describe: "SUBSTRING(字段名称,从第n个字符后开始截取,截取n个) 汉字、数字、英文占一个字符",
        },
        {
          num: 2,
          title: "字符串拼接",
          sqlText: "CONCAT(字段名称,'拼接内容')",
          describe: "CONCAT(字段名称,拼接内容,....)方法可添加多个用于拼接的内容 至少两个参数",
        },
        {
          num: 3,
          title: "大写变小写",
          sqlText: "LOWER(字段名称)",
          describe: "LOWER(字段名称)字符串大写变小写",
        },
        {
          num: 4,
          title: "小写变大写",
          sqlText: "UPPER(字段名称)",
          describe: "UPPER(字段名称)字符串小写变大写",
        },
        {
          num: 5,
          title: "替换",
          sqlText: "REPLACE(字段名称,'a','x')",
          describe: "REPLACE(字段名称,a,x)将该字符串中的x替代该字符串中的a",
        },
        {
          num: 6,
          title: "TRIM()",
          sqlText: "TRIM(字段名称)",
          describe: "TRIM(字段名称)去掉该字符串开始和结束处的空格",
        },
        {
          num: 7,
          title: "LTRIM()",
          sqlText: "LTRIM(字段名称)",
          describe: "LTRIM(字段名称)去掉该字符串开始处的空格",
        },
        {
          num: 8,
          title: "RTRIM()",
          sqlText: "RTRIM(字段名称)",
          describe: "RTRIM(字段名称)去掉该字符串结尾处的空格",
        },
      ],
      oracleMethodsList2: [
        {
          num: 1,
          title: "+",
          sqlText: "字段名称 + 1",
          describe: "该字段的数值 + 1",
        },
        {
          num: 2,
          title: "-",
          sqlText: "字段名称 - 1",
          describe: "该字段的数值 - 1",
        },
        {
          num: 3,
          title: "*",
          sqlText: "字段名称 * 2",
          describe: "该字段的数值 * 2",
        },
        {
          num: 4,
          title: "/",
          sqlText: "字段名称 / 2",
          describe: "该字段的数值 / 2",
        },
        {
          num: 5,
          title: "取2次方根",
          sqlText: "SQRT(字段名称)",
          describe: "该字段的数值取2次方方根",
        },
        {
          num: 6,
          title: "取n次方根",
          sqlText: "SQRT(POWER(字段名称,2))",
          describe: "该字段的数值取开n次方",
        },
      ],
      oracleMethodsList3: [
        {
          num: 1,
          title: "日期转时间戳",
          sqlText: "(SYSDATE - to_date(字段名称,'yyyy-mm-dd hh24:mi:ss'))*86400000",
          describe: "针对字段编辑语句中的 yyyy-mm-dd hh24:mi:ss",
        },
        {
          num: 2,
          title: "时间戳转字符串",
          sqlText: "TO_ CHAR(字段名称/(1000 * 60*60 * 24) + TO_DATE('1970-01-01 08:00:00','YYYY-MM-DD HH24:Ml:SS),'YYYY-MM-DD')",
          describe: "自定义yyyy/mm/dd的间隔格式;",
        },
        {
          num: 3,
          title: "fmt转日期",
          sqlText: "TO_DATE(字段名称,'yyyy/mm/dd')",
          describe: "自定义yyyy/mm/dd的间隔格式 TO_DATE('2020/11/02', 'yyyy/mm/dd');",
        },
        {
          num: 4,
          title: "日期加减",
          sqlText: "ADD_MONTHS(字段名称,10)",
          describe: "函数使用方法:ADD_MONTHS(字段名称,-12)(减一年)、字段名称 -1(减一天)、字段名称-24(减一小时)",
        },
        {
          num: 5,
          title: "日期格式截取",
          sqlText: "TO_CHAR(字段名称,'YYYY')",
          describe: "常用的type:YYYY(年)、MM(月)、DD(日)、HH24(时)、MI(分)、SS(秒)、",
        },
      ],
      DaMengMethodsList1: [
        {
          num: 1,
          title: "字符串截取",
          sqlText: "SUBSTRING(字段名称,1,2)",
          describe: "SUBSTRING(字段名称,从第n个字符后开始截取,截取n个) 汉字、数字、英文占一个字符",
        },
        {
          num: 2,
          title: "字符串拼接",
          sqlText: "CONCAT(字段名称,'拼接内容')",
          describe: "CONCAT(字段名称,拼接内容,....)方法可添加多个用于拼接的内容 至少两个参数",
        },
        {
          num: 3,
          title: "大写变小写",
          sqlText: "LCASE(字段名称)",
          describe: "LCASE(字段名称)字符串大写变小写",
        },
        {
          num: 4,
          title: "小写变大写",
          sqlText: "UCASE(字段名称)",
          describe: "UCASE(字段名称)字符串小写变大写",
        },
        {
          num: 5,
          title: "替换",
          sqlText: "REPLACE(字段名称,'a','x')",
          describe: "REPLACE(字段名称,a,x)将该字符串中的x替代该字符串中的a",
        },
        {
          num: 6,
          title: "LEFT()",
          sqlText: "LEFT(字段名称,2)",
          describe: "LEFT(字段名称,n)截取该字符串的前 n 个字符",
        },
        {
          num: 7,
          title: "LTRIM()",
          sqlText: "LTRIM(字段名称)",
          describe: "LTRIM(字段名称)去掉该字符串开始处的空格",
        },
        {
          num: 8,
          title: "RTRIM()",
          sqlText: "RTRIM(字段名称)",
          describe: "RTRIM(字段名称)去掉该字符串结尾处的空格",
        },
        {
          num: 9,
          title: "CAST()",
          sqlText: "CAST(字段名称 AS DATE)",
          describe: "CAST(字段名称 AS DATE) 转换数据类型",
        },
      ],
      DaMengMethodsList2: [
        {
          num: 1,
          title: "+",
          sqlText: "字段名称 + 1",
          describe: "该字段的数值 + 1",
        },
        {
          num: 2,
          title: "-",
          sqlText: "字段名称 - 1",
          describe: "该字段的数值 - 1",
        },
        {
          num: 3,
          title: "*",
          sqlText: "字段名称 * 2",
          describe: "该字段的数值 * 2",
        },
        {
          num: 4,
          title: "/",
          sqlText: "字段名称 / 2",
          describe: "该字段的数值 / 2",
        },
        {
          num: 5,
          title: "取绝对值",
          sqlText: "ABS(字段名称)",
          describe: "ABS(字段名称) 字段要求是整数类型",
        },
        {
          num: 6,
          title: "取n次方",
          sqlText: "POW(字段名称,2)",
          describe: "该字段的数值取n次方",
        },
      ],
      DaMengMethodsList3: [
        {
          num: 1,
          title: "获取当前日期",
          sqlText: "CURRENT_DATE()",
          describe: "获取当前日期",
        },
        {
          num: 2,
          title: "获取当前时间",
          sqlText: "CURRENT_TIME()",
          describe: "获取当前时间",
        },
        {
          num: 3,
          title: "获取当前日期和时间",
          sqlText: "CURRENT_TIMESTAMP()",
          describe: "获取当前日期和时间",
        },
        {
          num: 4,
          title: "获取当前年份",
          sqlText: "year(CURRENT_TIMESTAMP())",
          describe: "获取当前年份，不可操作",
        },
        {
          num: 5,
          title: "获取当前月份",
          sqlText: "month(CURRENT_TIMESTAMP())",
          describe: "获取当前月份，不可操作",
        },
        {
          num: 6,
          title: "获取当前天数",
          sqlText: "day(CURRENT_TIMESTAMP())",
          describe: "获取当前天数，不可操作",
        },
        {
          num: 7,
          title: "转时间戳",
          sqlText: " UNIX_TIMESTAMP(字段名称)",
          describe: "UNIX_TIMESTAMP(字段名称) 转时间戳",
        },
        {
          num: 8,
          title: "日期天数加减",
          sqlText: "ADD_DAYS(字段名称,10)",
          describe: "ADDDATE(字段名称,要加/减的天数)",
        },
        {
          num: 9,
          title: "时间间隔",
          sqlText: "DATEDIFF(MONTH,CURRENT_TIMESTAMP(),字段名称)",
          describe: "当前时间和目标日期的时间间隔",
        },
        {
          num: 10,
          title: "日期加减",
          sqlText: "DATEADD(YY,2,字段名称);",
          describe: "Y常用的类型:YY(年)、QQ(季度)、MM(月)、DD(天)、WW(周)、HH(时)、MI(分)、SS(秒)、MS(毫秒)",
        },
        {
          num: 11,
          title: "字符串转时间",
          sqlText: "to_date('字段名称','yyyy-MM-dd HH24:MI:SS');",
          describe: "时间格式的间隔符号可以自行定义",
        },

      ],
      KingBaseMethodsList1: [
        {
          num: 1,
          title: "字符串截取",
          sqlText: "SUBSTRING(字段名称,1,2)",
          describe: "SUBSTRING(字段名称,从第n个字符后开始截取,截取n个) 汉字、数字、英文占一个字符",
        },
        {
          num: 2,
          title: "字符串拼接",
          sqlText: "CONCAT(字段名称,'拼接内容')",
          describe: "CONCAT(字段名称,拼接内容,....)方法可添加多个用于拼接的内容 至少两个参数",
        },
        {
          num: 3,
          title: "大写变小写",
          sqlText: "LCASE(字段名称)",
          describe: "LCASE(字段名称)字符串大写变小写",
        },
        {
          num: 4,
          title: "小写变大写",
          sqlText: "UCASE(字段名称)",
          describe: "UCASE(字段名称)字符串小写变大写",
        },
        {
          num: 5,
          title: "替换",
          sqlText: "REPLACE(字段名称,'a','x')",
          describe: "REPLACE(字段名称,a,x)将该字符串中的x替代该字符串中的a",
        },
        {
          num: 6,
          title: "LEFT()",
          sqlText: "LEFT(字段名称,2)",
          describe: "LEFT(字段名称,n)截取该字符串的前 n 个字符",
        },
        {
          num: 7,
          title: "LTRIM()",
          sqlText: "LTRIM(字段名称)",
          describe: "LTRIM(字段名称)去掉该字符串开始处的空格",
        },
        {
          num: 8,
          title: "RTRIM()",
          sqlText: "RTRIM(字段名称)",
          describe: "RTRIM(字段名称)去掉该字符串结尾处的空格",
        },
        {
          num: 9,
          title: "CAST()",
          sqlText: "CAST(字段名称 AS DATE)",
          describe: "CAST(字段名称 AS DATE) 转换数据类型",
        },
      ],
      KingBaseMethodsList2: [
        {
          num: 1,
          title: "+",
          sqlText: "字段名称 + 1",
          describe: "该字段的数值 + 1",
        },
        {
          num: 2,
          title: "-",
          sqlText: "字段名称 - 1",
          describe: "该字段的数值 - 1",
        },
        {
          num: 3,
          title: "*",
          sqlText: "字段名称 * 2",
          describe: "该字段的数值 * 2",
        },
        {
          num: 4,
          title: "/",
          sqlText: "字段名称 / 2",
          describe: "该字段的数值 / 2",
        },
        {
          num: 5,
          title: "取绝对值",
          sqlText: "ABS(字段名称)",
          describe: "ABS(字段名称) 字段要求是整数类型",
        },
        {
          num: 6,
          title: "取n次方",
          sqlText: "POW(字段名称,2)",
          describe: "该字段的数值取n次方",
        },
        {
          num: 7,
          title: "取2次方根",
          sqlText: "SQRT(字段名称)",
          describe: "该字段的数值取2次方方根",
        },
        {
          num: 8,
          title: "取n次方根",
          sqlText: "SQRT(POWER(字段名称,2))",
          describe: "该字段的数值取开n次方",
        },
      ],
      KingBaseMethodsList3: [
        {
          num: 1,
          title: "获取当前日期",
          sqlText: "CURRENT_DATE()",
          describe: "获取当前日期",
        },
        {
          num: 2,
          title: "获取当前时间",
          sqlText: "CURRENT_TIME()",
          describe: "获取当前时间",
        },
        {
          num: 3,
          title: "获取当前日期和时间",
          sqlText: "CURRENT_TIMESTAMP()",
          describe: "获取当前日期和时间",
        },
        {
          num: 4,
          title: "时间转时间戳",
          sqlText: "extract(epoch from 字段名称::timestamp  at time zone 'PRC' )::integer",
          describe: "时间转时间戳",
        },
        {
          num: 5,
          title: "时间戳转时间",
          sqlText: "to_timestamp(字段名称)",
          describe: "时间戳转时间",
        },
        {
          num: 6,
          title: "日期加减",
          sqlText: "ADDDAYS(字段名称,10)",
          describe: "ADDDATE(日期字段/或者当前时间,要加/减的天数)",
        },
        {
          num: 7,
          title: "按月份的时间间隔",
          sqlText: "months_between(CURRENT_TIMESTAMP, 字段名称)",
          describe: "months_between(CURRENT_TIMESTAMP, 字段名称)",
        },
        {
          num: 8,
          title: "按天数的时间间隔",
          sqlText: "days_between(CURRENT_TIMESTAMP, 字段名称)",
          describe: "days_between(CURRENT_TIMESTAMP, 字段名称)",
        },
        {
          num: 9,
          title: "按秒数的时间间隔",
          sqlText: "timesub(CURRENT_TIMESTAMP, 字段名称)",
          describe: "timesub(CURRENT_TIMESTAMP, 字段名称)",
        },
        {
          num: 10,
          title: "字符串转时间",
          sqlText: "to_date('字段名称','YYYY-MM-DD HH24:MI:SS')",
          describe: "时间格式的间隔符号可以自行定义",
        },
        {
          num: 11,
          title: "截取日期年份",
          sqlText: "date_part('year','字段名称')",
          describe: "截取目标字段的年份信息",
        },
        {
          num: 12,
          title: "截取日期月份",
          sqlText: "date_part('month','字段名称')",
          describe: "截取目标字段的月份信息",
        },
        {
          num: 13,
          title: "截取日期天数",
          sqlText: "date_part('day','字段名称')",
          describe: "截取目标字段的天数信息",
        },
        {
          num: 14,
          title: "截取小时",
          sqlText: "date_part('hour','字段名称')",
          describe: "截取目标字段的小时信息",
        },
        {
          num: 15,
          title: "截取分钟",
          sqlText: "date_part('minute','字段名称')",
          describe: "截取目标字段的分钟信息",
        },
        {
          num: 16,
          title: "截取秒数",
          sqlText: "date_part('second','字段名称')",
          describe: "截取目标字段的秒数信息",
        },
        {
          num: 17,
          title: "时间字段加减",
          sqlText: "'字段名称' - interval'2 year'",
          describe: "目标字段加减的常用参数:year、month、day、hour、minute、second",
        },
      ],
      sqlText: '',
      // 切换算法和条件的参数
      tabFlag: '算法添加',
      // 字段
      fieldArr: [
        {
          fieldText: '',
          celect: '',
          fieldText2: '',
          fieldText3: ''
        }
      ],
      changeArr: [
        {
          fieldText: '',
          celect: '',
        }
      ],
      timeout: [
        '等于',
        '不等于',
        '大于',
        '小于',
        '大于等于',
        '小于等于',
        '包含',
        '不包含',
        '开头包含',
        '结尾包含',
        '为空',
        '不为空'
      ],
      changeCondition: [
        // '数值',
        '字符',
        // '日期',
      ],
      clearfieldArr: [
        {
          clearText: '',
          clearSymbol: '',
          clearText2: '',
          dataType: '',
          typeInfo: '',
          strList: [],
          specificTime: "",
        }
      ],
      strList: [],


      // ===================数据关联====================
      arrow: "el-icon-caret-right",
      drawerType,
      drawerConf: {
        title: "",
        visible: false,
        type: null,
        info: null,
        open: (type, info) => {
          const conf = this.drawerConf;
          conf.visible = true;
          conf.type = type;
          conf.info = info;
          if (conf.type === drawerType.node) {
            conf.title = "节点";
            if (this.$refs.nodeSetting) this.$refs.nodeSetting.resetFields();
            this.$set(this.nodeSetting, "name", info.meta.name);
            this.$set(this.nodeSetting, "desc", info.meta.desc);
          } else {
            this.startTab = this.drawerConf.info.start.meta.label.tableName;
            this.endTab = this.drawerConf.info._end.meta.name.tableName;
            conf.title = "连线";
            if (this.$refs.linkSetting) this.$refs.linkSetting.resetFields();
            this.$set(
              this.linkSetting,
              "desc",
              info.meta ? info.meta.desc : ""
            );
            this.$set(
              this.linkSetting,
              "startTabField",
              info.meta ? info.meta.startTabField : ""
            );
            this.$set(
              this.linkSetting,
              "endTabField",
              info.meta ? info.meta.endTabField : ""
            );

            GetFieldsInfo({
              dataSourceId: this.dataSet.id,
              tbName: this.startTab,
            }).then(res => {
              if (res.code === 200) {
                this.downTableArr1 = [];
                var i;
                var downTableArr1 = []
                for (i = 0; i < res.data.dataTabel.length; i++) {
                  downTableArr1.push(res.data.dataTabel[i].field)
                  this.downTableArr1 = downTableArr1;
                }
              }
            });

            setTimeout(() => {
              GetFieldsInfo2({
                dataSourceId: this.dataSet.id,
                tbName: this.endTab,
              }).then(res => {
                if (res.code === 200) {
                  this.downTableArr2 = [];
                  var i;
                  var downTableArr2 = []
                  for (i = 0; i < res.data.dataTabel.length; i++) {
                    downTableArr2.push(res.data.dataTabel[i].field)
                    this.downTableArr2 = downTableArr2;
                  }
                }
              });
            }, 1000);
          }
        },
        cancel: () => {
          this.drawerConf.visible = false;
          if (this.drawerConf.type === drawerType.node) {
            this.$refs.nodeSetting.clearValidate();
          } else {
            this.$refs.linkSetting.clearValidate();
          }
        },
      },
      linkSetting: {
        desc: "",
        startTabField: "",
        endTabField: "",
      },
      nodeSetting: {
        name: "",
        desc: "",
      },

      dragConf: {
        isDown: false,
        isMove: false,
        offsetTop: 0,
        offsetLeft: 0,
        clientX: 0,
        clientY: 0,
        ele: null,
        info: null,
      },
      parentList: [
        {
          title: "当前数据表",
          id: 1,
          nodeItemList: [
          ],
        },
      ],
      graphMenu: [
      ],
      nodeMenu: [
        [
          {
            label: "删除",
            selected: (node) => {
              node.remove();
            },
          },
          // {
          //   label: "编辑",
          //   selected: (node) => {
          //     this.drawerConf.open(drawerType.node, node);
          //   },
          // },
        ],
      ],
      linkMenu: [
        [
          {
            label: "删除",
            selected: (link) => {
              link.remove();
            },
          },
          {
            label: "编辑",
            selected: (link) => {
              this.drawerConf.open(drawerType.link, link);
            },
          },
        ],
      ],

      linkBaseStyle: {
        color: "#666666", // line 颜色
        hover: "#FF0000", // line hover 的颜色
        textColor: "#666666", // line 描述文字颜色
        textHover: "#FF0000", // line 描述文字 hover 颜色
        font: "14px Arial", // line 描述文字 字体设置 参考 canvas font
        dotted: false, // 是否是虚线
        lineDash: [4, 4], // 虚线时生效
        background: "rgba(255,255,255,0.6)", // 描述文字背景色
      },

    }
  },

  computed: {
    NewDeviceList() {
      // 新的赋值
      return JSON.parse(JSON.stringify(this.fieldArr));
    }
  },
  watch: {
    sqlText() {
      this.sqlChange = true;
      this.addBtn = false;
    },
    NewDeviceList: {
      deep: true,
      handler(newValue, oldValue) {
        for (let i = 0; i < newValue.length; i++) {
          if (oldValue[i] != newValue[i]) {
          }
        }
        this.conditionChange = true;
        this.addBtn = false;
      }
    },
    otherwise() {
      this.conditionChange = true;
      this.addBtn = false;
    }
  },
  methods: {
    open(index) {
      this.$confirm('此操作将永久删除该表, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.chaTable(index),
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    open2(index) {
      this.$confirm('此操作将永久删除该字段, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.cha(index),
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    checkText(str) {
      var temp = "";
      for (var i = 0; i < str.length; i++)
        if (str.charCodeAt(i) > 0 && str.charCodeAt(i) < 255)
          temp += str.charAt(i)
      return temp
    },
    //删除数据关联
    chaTable(index) {
      var data = {}
      data = {
        dataSourceID: this.dataSet.id,//当前数据接入id
        tbName: this.tableAssociationList[index],//需要删除的字段
      }
      DelTableJoin(data).then(res => {
        if (res.code === 200) {
          this.getOrigTable();
        }
      })
    },
    cha(index) {
      var that = this;
      //遍历原有的全部字段
      that.c = this.addName[index];
      var i;
      var arr = []
      var obj = {}
      var data = {}
      if (this.origData.tableProp.length) {
        for (i = 0; i <= this.origData.tableProp.length - 1; i = i++) {
          obj = this.origData.tableProp[i].label
          arr.push(obj)
          i++;
        }
      } else if (!this.origData.tableProp.length) {
        for (var i = 0; i <= this.getFieldsInfo.length - 1; i = i++) {
          obj = this.getFieldsInfo[i]
          arr.push(obj)
          i++;
        }
      }
      //未选中的字段
      var x = arr;//原有字段
      var y = JSON.parse(JSON.stringify(this.arr1));
      var z = [];//未选中字段
      x.forEach((a) => {
        let c = y.findIndex(b => a == b);
        if (c > -1) delete y[c];
        else z.push(a);
      });
      z.forEach(function (item, index, arr) {
        if (item === that.c) {
          arr.splice(index, 1)
        }
      })
      var c = []
      c.push(that.c)
      data = {
        fields: z,//未选中字段
        delFields: c,//需要删除的字段
        tableName: this.dataSet.origList[this.activeDataSet.orig].tableName,//当前字段所在的表名
        dataSourceID: this.dataSet.id,//当前数据接入id
        logicalDeletion: 1,
      }
      DelField(data).then(res => {
        if (res.code === 200) {
          // this.del.dialog = false;
          this.getOrigTableList();
          GetFieldsInfo({
            dataSourceId: this.dataSet.id,
            tbName: this.dataSet.origList[this.activeDataSet.orig].tableName,
          }).then(res => {
            if (res.code === 200) {
              this.downTableArr1 = [];
              var i;
              var downTableArr1 = []
              for (i = 0; i < res.data.dataTabel.length; i++) {
                downTableArr1.push(res.data.dataTabel[i].field)
                this.getFieldsInfo = downTableArr1;
              }
            }
          });
        }
      })
    },
    //数据过滤弹窗确定按钮
    dataFiltering() {
      var clearArr = JSON.parse(JSON.stringify(this.clearfieldArr));
      let dataGl = []
      var dataType = "";
      var typeInfo = ""
      clearArr.forEach(item => {
        if (item.dataType == "年") {
          dataType = 1
        } else if (item.dataType == "月") {
          dataType = 2
        } else if (item.dataType == "日") {
          dataType = 3
        } else if (item.dataType == "时间") {
          dataType = 4
        }
        if (item.typeInfo == 1) {
          typeInfo = 0
          dataType = 0
        } else if (item.typeInfo == 2) {
          typeInfo = 2
        } else if (item.typeInfo == 3) {
          typeInfo = 1
          dataType = 0
        }
        if (item.clearSymbol != "区间" && item.clearSymbol != "为空" && item.clearSymbol != "不为空") {
          var clearText2 = [];
          clearText2.push(item.clearText2)
        } else if (item.clearSymbol == "区间") {
          var clearText2 = item.clearText2
        } else if (item.clearSymbol == "为空" || item.clearSymbol != "不为空") {
          var clearText2 = [];
        }

        dataGl.push({
          fieldType: typeInfo,//字段类型
          dateType: dataType,
          val1: clearText2,//判断值1
          valType: item.clearSymbol,//数据过滤类型
          fields: item.clearText,//字段
        })
        for (let i in this.clearfieldArr[this.clearfieldArr.length - 1]) {
          if (!this.clearfieldArr[this.clearfieldArr.length - 1][i] && item.clearSymbol != '为空' && item.clearSymbol != '不为空') {
            this.getMsg('请先完善当前筛选条件');
            return;
          } else {
            this.dataGl = dataGl;
            let data = {}

            data = {
              dataSourceID: this.dataSet.id,//当前数据接入id
              tbName: this.dataSet.origList[this.activeDataSet.orig].tableName,//当前表名称
              filters: this.dataGl,
            }
            CreateFilter(data).then(res => {
              if (res.code === 200) {
                // this.clear.dialog = false;
                this.clearDialog(1)
                this.getMsg(res.message, 'success');
                this.getOrigTableList();
              }
            })
            return
          }
        }
      })

    },
    resetting() {

      // this.clearfieldArr = [
      //   {
      //     clearText: '',
      //     clearSymbol: '',
      //     clearText2: '',
      //   }
      // ]
      this.clearfieldArr = [
        {
          clearText: '',
          clearSymbol: '',
          clearText2: '',
          dataType: '',
          typeInfo: '',
          strList: [],
        }
      ];
      var clearArr = JSON.parse(JSON.stringify(this.clearfieldArr));
      let arrList = [];
      clearArr.forEach(item => {
        arrList.push({
          fieldType: 0,//字段类型
          val1: [],//判断值1
          val2: "",
          valType: "",//数据过滤类型
          fields: "",//字段
        })
      })
      let data = {}
      data = {
        dataSourceID: this.dataSet.id,//当前数据接入id
        tbName: this.dataSet.origList[this.activeDataSet.orig].tableName,//当前表名称
        filters: arrList,
      }
      CreateFilter(data).then(res => {
        if (res.code === 200) {
          this.clear.dialog = false;
          this.getMsg(res.message, 'success');
          this.getOrigTableList();
        }
      })
    },
    //循环表名
    fortableName() {
      this.parentList[0].nodeItemList = [];
      this.dataSet.origList.forEach((item, index) => {
        var obj = {
          label: item,
          value: {
            width: 150,
            height: 40,
            border: 0,
            meta: {
              label: item,
              name: item,
            },
          },
        }
        this.parentList[0].nodeItemList.push(obj)
      });

      this.table.dialog = true;
    },
    quxiao() {
      this.add.dialog = false;
      this.del.dialog = false;
      this.clear.dialog = false;
    },
    //删除字段弹窗，确定按钮
    delDetermine() {
      //遍历原有的全部字段
      if (this.origData.tableProp.length) {
        var arr = []
        var obj = {}
        for (var i = 0; i <= this.origData.tableProp.length - 1; i = i++) {
          obj = this.origData.tableProp[i].label
          arr.push(obj)
          i++;
        }
      } else if (!this.origData.tableProp.length) {
        var arr = []
        var obj = {}
        for (var i = 0; i <= this.getFieldsInfo.length - 1; i = i++) {
          obj = this.getFieldsInfo[i]
          arr.push(obj)
          i++;
        }
      }
      //未选中的字段
      var x = arr;//原有字段
      var y = JSON.parse(JSON.stringify(this.arr1));
      var z = [];//未选中字段
      x.forEach((a) => {
        let c = y.findIndex(b => a == b);
        if (c > -1) delete y[c];
        else z.push(a);
      });
      if (this.arr1 == '') {
        this.getMsg('您未选中任何需删除的字段！');
        return
      }else if(z.length==0){
        this.getMsg('您至少要保留一个字段！');
        return
      } else if (this.origData.tableProp.length !== this.arr1.length || this.getFieldsInfo.length !== this.arr1.length) {

        var data = {}
        data = {
          fields: z,//未选中字段
          delFields: this.arr1,//需要删除的字段
          tableName: this.dataSet.origList[this.activeDataSet.orig].tableName,//当前字段所在的表名
          dataSourceID: this.dataSet.id,//当前数据接入id
          logicalDeletion: 0,

        }
        DelField(data).then(res => {
          if (res.code === 200) {
            this.del.dialog = false;
            this.getMsg(res.message, 'success');
            this.getOrigTableList();
            GetFieldsInfo({
              dataSourceId: this.dataSet.id,
              tbName: this.dataSet.origList[this.activeDataSet.orig].tableName,
            }).then(res => {
              if (res.code === 200) {
                this.downTableArr1 = [];
                var i;
                var downTableArr1 = []
                for (i = 0; i < res.data.dataTabel.length; i++) {
                  downTableArr1.push(res.data.dataTabel[i].field)
                  this.getFieldsInfo = downTableArr1;
                }
              }
            });
          }
        })
      } 
    },
    //恢复已删除的字段
    recoveryField() {
      if (this.arrHF == '') {
        this.getMsg('您未选中任何待恢复的字段！');
        return
      } else {
        var data = {
          restores: this.arrHF,//需要恢复的字段
          tbName: this.dataSet.origList[this.activeDataSet.orig].tableName,//当前字段所在的表名
          dataSourceID: this.dataSet.id,//当前数据接入id
        }
        RestoreField(data).then(res => {
          if (res.code === 200) {
            this.arrHF = []
            this.del.dialog = false;
            this.getMsg(res.message, 'success');
            this.getOrigTableList();
            GetFieldsInfo({
              dataSourceId: this.dataSet.id,
              tbName: this.dataSet.origList[this.activeDataSet.orig].tableName,
            }).then(res => {
              if (res.code === 200) {
                this.downTableArr1 = [];
                var i;
                var downTableArr1 = []
                for (i = 0; i < res.data.dataTabel.length; i++) {
                  downTableArr1.push(res.data.dataTabel[i].field)
                  this.getFieldsInfo = downTableArr1;
                }
              }
            });
          }
        })
      }
    },
    //算法编译
    compile() {
      let data = {};
      //遍历fields参数的结果
      var arr = []
      var obj = {}
      for (var i = 0; i <= this.origData.tableProp.length - 1; i = i++) {
        obj = this.origData.tableProp[i].label
        arr.push(obj)
        i++;
      }
      //判断，算法是否已选择
      if (!this.sqlText) {
        this.getMsg('请通过算法处理字段');
        return;
      } else if (this.sqlText.indexOf("字段名称") != -1) {
        this.getMsg('请选择左侧需要处理的字段');
        return;
      } else {
        data = {
          fields: arr,//当前表的所有字段，可为空
          tableName: this.dataSet.origList[this.activeDataSet.orig].tableName,//当前表名 必须
          dataSourceID: this.dataSet.id,//当前数据接入ID 必须
          type: 0,//0：编译 1：保存
          functionSQL: [
            {
              functions: this.sqlText,//算法
              functionAlias: ''//算法别名
            }
          ]
        }
      }
      AddField(data).then(res => {
        this.sqlChange = false;
        if (res.code === 200) {
          this.compileAdd = false;
          this.getMsg(res.message, 'success');
          this.addBtn = true;
        }
      })
    },
    //条件编译
    condition() {
      let data = {}
      var arr = []
      var obj = {}
      for (var i = 0; i <= this.origData.tableProp.length - 1; i = i++) {
        obj = this.origData.tableProp[i].label
        arr.push(obj)
        i++;
      }
      //每一行筛选行信息值
      let arrList = [];
      this.fieldArr.forEach(item => {
        arrList.push({
          field: item.fieldText,//字段名
          ifType: item.celect,//运算符号
          val: item.fieldText2,//判断值
          resultVal: item.fieldText3,//返回值
        })
      })
      for (var i in this.fieldArr[this.fieldArr.length - 1]) {
        if (!this.fieldArr[this.fieldArr.length - 1][i]) {
          if (this.fieldArr[this.fieldArr.length - 1].celect != '不为空' && this.fieldArr[this.fieldArr.length - 1].celect != '为空') {
            this.getMsg('请完善当前条件添加信息');
            return;
          }
        }
      }
      if (!this.otherwise) {
        this.getMsg('请完善当前条件添加信息');
        return;
      }
      data = {
        fields: arr,//当前表的所有字段，可为空
        tableName: this.dataSet.origList[this.activeDataSet.orig].tableName,//当前表名 必须
        dataSourceID: this.dataSet.id,//当前数据接入ID 必须
        caseAlias: '',//字段名称 必须
        caseELSE: this.otherwise,//ELSE内容 必须
        type: 0,//0：编译 1：保存
        caseFields: arrList
      }
      AddCaseWhen(data).then(res => {
        this.conditionChange = false;
        if (res.code === 200) {
          this.addBtn = true;
          this.getMsg(res.message, 'success');
          this.getOrigTableList();
        }
      })
      return

    },
    //添加保存
    saveField() {
      let data = {};
      //遍历fields参数的结果
      var i;
      var arr = []
      var obj = {}
      for (i = 0; i <= this.origData.tableProp.length - 1; i = i++) {
        obj = this.origData.tableProp[i].label
        arr.push(obj)
        i++;
      }
      if (this.tabFlag == '算法添加') {
        if (!this.fieldName) {
          this.getMsg('请输入字段名称');
          return;
        } else {
          var regPos = /^\d+(\.\d+)?$/; //非负浮点数
          var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
          if (regPos.test(this.fieldName) || regNeg.test(this.fieldName)) {
            this.getMsg('新表名称不可以是纯数字！');
            return;
          }
        }
        if (this.fieldName.indexOf("!") != -1 || this.fieldName.indexOf("@") != -1 || this.fieldName.indexOf("#") != -1 || this.fieldName.indexOf("$") != -1 || this.fieldName.indexOf("%") != -1 || this.fieldName.indexOf("^") != -1 || this.fieldName.indexOf("&") != -1 || this.fieldName.indexOf("*") != -1 || this.fieldName.indexOf("(") != -1 || this.fieldName.indexOf(")") != -1 || this.fieldName.indexOf("'\'") != -1 || this.fieldName.indexOf(":") != -1 || this.fieldName.indexOf(";") != -1 || this.fieldName.indexOf('"') != -1 || this.fieldName.indexOf("'") != -1 || this.fieldName.indexOf("<") != -1 || this.fieldName.indexOf(",") != -1 || this.fieldName.indexOf(">") != -1 || this.fieldName.indexOf(".") != -1 || this.fieldName.indexOf("/") != -1 || this.fieldName.indexOf("?") != -1 || this.fieldName.indexOf("-") != -1 || this.fieldName.indexOf("+") != -1 || this.fieldName.indexOf("！") != -1 || this.fieldName.indexOf("￥") != -1 || this.fieldName.indexOf("…") != -1 || this.fieldName.indexOf("&") != -1 || this.fieldName.indexOf("*") != -1 || this.fieldName.indexOf("（") != -1 || this.fieldName.indexOf("）") != -1 || this.fieldName.indexOf("—") != -1 || this.fieldName.indexOf("；") != -1 || this.fieldName.indexOf("：") != -1 || this.fieldName.indexOf("‘") != -1 || this.fieldName.indexOf("“") != -1 || this.fieldName.indexOf("，") != -1 || this.fieldName.indexOf("《") != -1 || this.fieldName.indexOf("》") != -1 || this.fieldName.indexOf("、") != -1 || this.fieldName.indexOf("？") != -1 || this.fieldName.indexOf("/") != -1) {
          this.getMsg('字段名称不可以使用特殊字符！');
          return;
        }
        if (this.fieldName && this.origData.tableProp) {
          for (var i = 0; i <= this.origData.tableProp.length - 1; i++) {
            var a = this.fieldName.toLowerCase();
            var b = arr[i].toLowerCase();
            if (a === b) {
              this.getMsg('字段名重复，请重新输入');
              return;
            }
          }
        }
        if (!this.sqlText) {
          this.getMsg('请通过算法处理字段');
          return;
        } else if (this.sqlText.indexOf("字段名称") != -1) {
          this.getMsg('请选择左侧需要处理的字段');
          return;
        } else if (this.sqlText.indexOf("字段名称") == -1) {
          data = {
            fields: arr,//当前表的所有字段，可为空
            tableName: this.dataSet.origList[this.activeDataSet.orig].tableName,//当前表名 必须
            dataSourceID: this.dataSet.id,//当前数据接入ID 必须
            type: 1,//0：编译 1：保存
            functionSQL: [
              {
                functions: this.sqlText,//算法
                functionAlias: this.fieldName//算法别名
              }
            ]
          }
          AddField(data).then(res => {
            if (res.code === 200) {
              this.fieldName = "";
              this.sqlText = "";
              this.fieldArr = [
                {
                  fieldText: '',
                  celect: '',
                  fieldText2: '',
                  fieldText3: ''
                }
              ];
              this.otherwise = ""
              this.getMsg(res.message, 'success');
              this.getOrigTableList();
              this.add.dialog = false;
              GetFieldsInfo({
                dataSourceId: this.dataSet.id,
                tbName: this.dataSet.origList[this.activeDataSet.orig].tableName,
              }).then(res => {
                if (res.code === 200) {
                  this.downTableArr1 = [];
                  var i;
                  var downTableArr1 = []
                  for (i = 0; i < res.data.dataTabel.length; i++) {
                    downTableArr1.push(res.data.dataTabel[i].field)
                    this.getFieldsInfo = downTableArr1;
                  }
                }
              });
            }
          })
        }
      }

      if (this.tabFlag == '条件添加') {
        if (!this.fieldName) {
          this.getMsg('请输入字段名字');
          return;
        } else {
          var regPos = /^\d+(\.\d+)?$/; //非负浮点数
          var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
          if (regPos.test(this.fieldName) || regNeg.test(this.fieldName)) {
            this.getMsg('新表名称不可以是纯数字！');
            return;
          }
        }
        if (this.fieldName.indexOf("!") != -1 || this.fieldName.indexOf("@") != -1 || this.fieldName.indexOf("#") != -1 || this.fieldName.indexOf("$") != -1 || this.fieldName.indexOf("%") != -1 || this.fieldName.indexOf("^") != -1 || this.fieldName.indexOf("&") != -1 || this.fieldName.indexOf("*") != -1 || this.fieldName.indexOf("(") != -1 || this.fieldName.indexOf(")") != -1 || this.fieldName.indexOf("'\'") != -1 || this.fieldName.indexOf(":") != -1 || this.fieldName.indexOf(";") != -1 || this.fieldName.indexOf('"') != -1 || this.fieldName.indexOf("'") != -1 || this.fieldName.indexOf("<") != -1 || this.fieldName.indexOf(",") != -1 || this.fieldName.indexOf(">") != -1 || this.fieldName.indexOf(".") != -1 || this.fieldName.indexOf("/") != -1 || this.fieldName.indexOf("?") != -1 || this.fieldName.indexOf("-") != -1 || this.fieldName.indexOf("+") != -1 || this.fieldName.indexOf("！") != -1 || this.fieldName.indexOf("￥") != -1 || this.fieldName.indexOf("…") != -1 || this.fieldName.indexOf("&") != -1 || this.fieldName.indexOf("*") != -1 || this.fieldName.indexOf("（") != -1 || this.fieldName.indexOf("）") != -1 || this.fieldName.indexOf("—") != -1 || this.fieldName.indexOf("；") != -1 || this.fieldName.indexOf("：") != -1 || this.fieldName.indexOf("‘") != -1 || this.fieldName.indexOf("“") != -1 || this.fieldName.indexOf("，") != -1 || this.fieldName.indexOf("《") != -1 || this.fieldName.indexOf("》") != -1 || this.fieldName.indexOf("、") != -1 || this.fieldName.indexOf("？") != -1 || this.fieldName.indexOf("/") != -1) {
          this.getMsg('字段名称不可以使用特殊字符！');
          return;
        }
        if (this.fieldName && this.origData.tableProp) {
          for (var i = 0; i <= this.origData.tableProp.length - 1; i++) {
            var a = this.fieldName.toLowerCase();
            var b = arr[i].toLowerCase();
            if (a === b) {
              this.getMsg('字段名重复，请重新输入');
              return;
            }
          }
        }
        for (var i in this.fieldArr[this.fieldArr.length - 1]) {
          if (!this.fieldArr[this.fieldArr.length - 1][i]) {
            if (this.fieldArr[this.fieldArr.length - 1].celect != '不为空' && this.fieldArr[this.fieldArr.length - 1].celect != '为空') {
              this.getMsg('请完善当前条件添加信息');
              return;
            }
          }
        }
        if (!this.otherwise) {
          this.getMsg('请完善当前条件添加信息');
          return;
        }
      }

      let arrList = [];
      this.fieldArr.forEach(item => {
        arrList.push({
          field: item.fieldText,//字段名
          ifType: item.celect,//运算符号
          val: item.fieldText2,//判断值
          resultVal: item.fieldText3,//返回值
        })
      })
      for (let i in this.fieldArr[this.fieldArr.length - 1]) {
        if (this.fieldArr[this.fieldArr.length - 1][i] && this.tabFlag == '条件添加') {
          data = {
            fields: arr,//当前表的所有字段，可为空
            tableName: this.dataSet.origList[this.activeDataSet.orig].tableName,//当前表名 必须
            dataSourceID: this.dataSet.id,//当前数据接入ID 必须
            caseAlias: this.fieldName,//字段名称 必须
            caseELSE: this.otherwise,//ELSE内容 必须
            type: 1,//0：编译 1：保存
            caseFields: arrList
          }
          AddCaseWhen(data).then(res => {
            if (res.code === 200) {
              this.add.dialog = false;
              this.getMsg(res.message, 'success');
              this.getOrigTableList();
              this.add.dialog = false;
              GetFieldsInfo({
                dataSourceId: this.dataSet.id,
                tbName: this.dataSet.origList[this.activeDataSet.orig].tableName,
              }).then(res => {
                if (res.code === 200) {
                  this.downTableArr1 = [];
                  var i;
                  var downTableArr1 = []
                  for (i = 0; i < res.data.dataTabel.length; i++) {
                    downTableArr1.push(res.data.dataTabel[i].field)
                    this.getFieldsInfo = downTableArr1;
                  }
                }
              });
            }
          })
        }
        return
      }

    },
    //添加修改
    changeField() {
      if (this.tabFlag == '算法添加') {
        let data = {}
        if (!this.fieldName) {
          this.getMsg('请输入字段名字');
          return;
        } else {
          var regPos = /^\d+(\.\d+)?$/; //非负浮点数
          var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
          if (regPos.test(this.fieldName) || regNeg.test(this.fieldName)) {
            this.getMsg('新表名称不可以是纯数字！');
            return;
          }
        }
        if (this.fieldName.indexOf("!") != -1 || this.fieldName.indexOf("@") != -1 || this.fieldName.indexOf("#") != -1 || this.fieldName.indexOf("$") != -1 || this.fieldName.indexOf("%") != -1 || this.fieldName.indexOf("^") != -1 || this.fieldName.indexOf("&") != -1 || this.fieldName.indexOf("*") != -1 || this.fieldName.indexOf("(") != -1 || this.fieldName.indexOf(")") != -1 || this.fieldName.indexOf("'\'") != -1 || this.fieldName.indexOf(":") != -1 || this.fieldName.indexOf(";") != -1 || this.fieldName.indexOf('"') != -1 || this.fieldName.indexOf("'") != -1 || this.fieldName.indexOf("<") != -1 || this.fieldName.indexOf(",") != -1 || this.fieldName.indexOf(">") != -1 || this.fieldName.indexOf(".") != -1 || this.fieldName.indexOf("/") != -1 || this.fieldName.indexOf("?") != -1 || this.fieldName.indexOf("-") != -1 || this.fieldName.indexOf("+") != -1 || this.fieldName.indexOf("！") != -1 || this.fieldName.indexOf("￥") != -1 || this.fieldName.indexOf("…") != -1 || this.fieldName.indexOf("&") != -1 || this.fieldName.indexOf("*") != -1 || this.fieldName.indexOf("（") != -1 || this.fieldName.indexOf("）") != -1 || this.fieldName.indexOf("—") != -1 || this.fieldName.indexOf("；") != -1 || this.fieldName.indexOf("：") != -1 || this.fieldName.indexOf("‘") != -1 || this.fieldName.indexOf("“") != -1 || this.fieldName.indexOf("，") != -1 || this.fieldName.indexOf("《") != -1 || this.fieldName.indexOf("》") != -1 || this.fieldName.indexOf("、") != -1 || this.fieldName.indexOf("？") != -1 || this.fieldName.indexOf("/") != -1) {
          this.getMsg('字段名称不可以使用特殊字符！');
          return;
        }
        if (!this.sqlText) {
          this.getMsg('请通过算法处理字段')
          return;
        }
        data = {
          functions: this.sqlText,//算法
          functionAlias: this.fieldName,//字段名称
          oldAlias: this.fieldAlias,//旧的字段名称
          tableName: this.dataSet.origList[this.activeDataSet.orig].tableName,//当前表名 必须
          dataSourceID: this.dataSet.id,//当前数据接入ID 必须
        }
        UpdateFuns(data).then(res => {
          if (res.code === 200) {
            this.add.dialog = false;
            this.getMsg(res.message, 'success');
            this.getOrigTableList();
          }
        })
      }
      if (this.tabFlag == '条件添加') {
        let data = {}
        var arr = []
        var obj = {}
        var i;

        for (i = 0; i <= this.origData.tableProp.length - 1; i = i++) {
          obj = this.origData.tableProp[i].label
          arr.push(obj)
          i++;
        }
        let arrList = [];
        this.fieldArr.forEach(item => {
          arrList.push({
            field: item.fieldText,//字段名
            ifType: item.celect,//运算符号
            val: item.fieldText2,//判断值
            resultVal: item.fieldText3,//返回值
          })
        })
        if (!this.fieldName) {
          this.getMsg('请输入字段名字');
          return;
        } else {
          var regPos = /^\d+(\.\d+)?$/; //非负浮点数
          var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
          if (regPos.test(this.fieldName) || regNeg.test(this.fieldName)) {
            this.getMsg('新表名称不可以是纯数字！');
            return;
          }
        }
        if (this.fieldName.indexOf("!") != -1 || this.fieldName.indexOf("@") != -1 || this.fieldName.indexOf("#") != -1 || this.fieldName.indexOf("$") != -1 || this.fieldName.indexOf("%") != -1 || this.fieldName.indexOf("^") != -1 || this.fieldName.indexOf("&") != -1 || this.fieldName.indexOf("*") != -1 || this.fieldName.indexOf("(") != -1 || this.fieldName.indexOf(")") != -1 || this.fieldName.indexOf("'\'") != -1 || this.fieldName.indexOf(":") != -1 || this.fieldName.indexOf(";") != -1 || this.fieldName.indexOf('"') != -1 || this.fieldName.indexOf("'") != -1 || this.fieldName.indexOf("<") != -1 || this.fieldName.indexOf(",") != -1 || this.fieldName.indexOf(">") != -1 || this.fieldName.indexOf(".") != -1 || this.fieldName.indexOf("/") != -1 || this.fieldName.indexOf("?") != -1 || this.fieldName.indexOf("-") != -1 || this.fieldName.indexOf("+") != -1 || this.fieldName.indexOf("！") != -1 || this.fieldName.indexOf("￥") != -1 || this.fieldName.indexOf("…") != -1 || this.fieldName.indexOf("&") != -1 || this.fieldName.indexOf("*") != -1 || this.fieldName.indexOf("（") != -1 || this.fieldName.indexOf("）") != -1 || this.fieldName.indexOf("—") != -1 || this.fieldName.indexOf("；") != -1 || this.fieldName.indexOf("：") != -1 || this.fieldName.indexOf("‘") != -1 || this.fieldName.indexOf("“") != -1 || this.fieldName.indexOf("，") != -1 || this.fieldName.indexOf("《") != -1 || this.fieldName.indexOf("》") != -1 || this.fieldName.indexOf("、") != -1 || this.fieldName.indexOf("？") != -1 || this.fieldName.indexOf("/") != -1) {
          this.getMsg('字段名称不可以使用特殊字符！');
          return;
        }
        data = {
          fields: arr,//当前表的所有字段，可为空
          tableName: this.dataSet.origList[this.activeDataSet.orig].tableName,//当前表名 必须
          dataSourceID: this.dataSet.id,//当前数据接入ID 必须
          caseAlias: this.fieldName,//字段名称 必须
          oldAlias: this.fieldCaseAlias,//字段名称 必须
          caseELSE: this.otherwise,//else的内容
          caseFields: arrList,
        }
        UpdateCase(data).then(res => {
          if (res.code === 200) {
            this.add.dialog = false;
            this.getMsg(res.message, 'success');
            this.getOrigTableList();
          }
        })
      }
    },
    //数据关联的保存按钮
    associationSave() {
      if (!this.associationName) {
        this.getMsg('请输入新表名称');
        return;
      } else {
        var regPos = /^\d+(\.\d+)?$/; //非负浮点数
        var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
        if (regPos.test(this.associationName) || regNeg.test(this.associationName)) {
          this.getMsg('新表名称不可以是纯数字！');
          return;
        }
      }
      if (this.associationName.indexOf("!") != -1 || this.associationName.indexOf("@") != -1 || this.associationName.indexOf("#") != -1 || this.associationName.indexOf("$") != -1 || this.associationName.indexOf("%") != -1 || this.associationName.indexOf("^") != -1 || this.associationName.indexOf("&") != -1 || this.associationName.indexOf("*") != -1 || this.associationName.indexOf("(") != -1 || this.associationName.indexOf(")") != -1 || this.associationName.indexOf("'\'") != -1 || this.associationName.indexOf(":") != -1 || this.associationName.indexOf(";") != -1 || this.associationName.indexOf('"') != -1 || this.associationName.indexOf("'") != -1 || this.associationName.indexOf("<") != -1 || this.associationName.indexOf(",") != -1 || this.associationName.indexOf(">") != -1 || this.associationName.indexOf(".") != -1 || this.associationName.indexOf("/") != -1 || this.associationName.indexOf("?") != -1 || this.associationName.indexOf("-") != -1 || this.associationName.indexOf("+") != -1 || this.associationName.indexOf("！") != -1 || this.associationName.indexOf("￥") != -1 || this.associationName.indexOf("…") != -1 || this.associationName.indexOf("&") != -1 || this.associationName.indexOf("*") != -1 || this.associationName.indexOf("（") != -1 || this.associationName.indexOf("）") != -1 || this.associationName.indexOf("—") != -1 || this.associationName.indexOf("；") != -1 || this.associationName.indexOf("：") != -1 || this.associationName.indexOf("‘") != -1 || this.associationName.indexOf("“") != -1 || this.associationName.indexOf("，") != -1 || this.associationName.indexOf("《") != -1 || this.associationName.indexOf("》") != -1 || this.associationName.indexOf("、") != -1 || this.associationName.indexOf("？") != -1 || this.associationName.indexOf("/") != -1) {
        this.getMsg('新表名称不可以使用特殊字符！');
        return;
      }
      this.arrList2 = JSON.stringify(this.arrList);
      if (this.arrList.length == 0) {
        this.getMsg('请拖拽左侧表进行连线并配置关联关系！');
        return;
      }
      JoinTables({
        tableName: this.associationName,//当前表名
        dataSourceID: this.dataSet.id,//当前数据接入id
        type: 1,//0预览;1保存
        dbTableJoins: this.arrList,
      }).then(res => {
        if (res.code === 200) {
          this.table.dialog = false;
          this.getMsg(res.message, 'success');
          this.getOrigTable();
          // window.location.reload();
        }
      }).catch(() => {
      });
      setTimeout(() => {
        this.dataSet.load = false;
      }, 300)
    },

    async init() {
      let setId = this.getSession('view_setId_xy');
      let chartsId = this.getSession('view_chartsId_xy');
      let sourceId = this.getSession('view_source_xy');
      if (setId && sourceId) {
        this.ViewDP.id = setId;
        this.ViewDP.sourceId = sourceId;
      } else {
        this.$router.push('/viewSet');
        return;
      }
      if (await !this.getTestViewSet(this.ViewDP.sourceId)) {
        this.$router.push('/viewSet');
        return;
      }
      //多维分析
      this.$store.state.dpType = 0;
      await this.$store.dispatch('clearViewDP');
      if (chartsId) {
        this.type = '修改';
      } else {
        this.type = '创建';
      }
      this.vuexViewDP = JSON.parse(JSON.stringify(this.state.viewDP));
      await this.getViewSetList();
      await this.getFieList();
      await this.getChartsAll();
      if (this.type === '修改') {
        this.getDetailsChart(chartsId);
      }
    },
    init() {
      this.getDataSoureList();
      this.fortableName();
    },
    getDataSoureList() {
      this.tableData.load = true;
      GetDataSourceTableList({
        pageIndex: this.tableData.pageIndex,
        pageSize: this.tableData.pageSize,
      }).then(res => {
        if (res.code === 200) {
          this.tableData.list = res.data.dataTabel;
          this.tableData.total = res.data.totalCount;
        }
        this.tableData.load = false;
      }).catch(() => {
        this.tableData.load = false;
      })
    },
    getPage(index, size) {
      this.tableData.pageIndex = index;
      this.tableData.pageSize = size;
      this.getOrigTableList();
    },
    //开始拖拽
    getDragStart(item) {
      this.dropWDS = {
        label: item.label,
      }
      this.dropDIFF = {
        title: item.title,
      }
      this.dropCIRCLE = {
        title: item,
      }
    },
    //拖拽结束
    getDragOver($event) {
      $event.preventDefault()
    },
    //生成拖动的数据
    getDrag(index, $event) {
      if (index === 0) {
        this.NeedList1.push({
          label: this.dropWDS.label
        });
      }
      if (index === 1) {
        this.NeedList2.push({
          title: this.dropDIFF.title
        });
      }
      if (index === 2) {
        this.NeedList3.push({
          table: this.dropCIRCLE.title
        });
      }
    },
    //数据过滤新增一行
    addClearInput() {
      if (this.clearfieldArr[this.clearfieldArr.length - 1].clearSymbol != '不为空' && this.clearfieldArr[this.clearfieldArr.length - 1].clearSymbol != '为空' && this.clearfieldArr[this.clearfieldArr.length - 1].clearSymbol != '区间') {
        if (!this.clearfieldArr[this.clearfieldArr.length - 1].clearText || !this.clearfieldArr[this.clearfieldArr.length - 1].clearSymbol || !this.clearfieldArr[this.clearfieldArr.length - 1].clearText2) {
          this.getMsg('请完善当前筛选条件信息');
          return;
        }
      } else if (this.clearfieldArr[this.clearfieldArr.length - 1].clearSymbol == '不为空' || this.clearfieldArr[this.clearfieldArr.length - 1].clearSymbol == '为空') {
        if (!this.clearfieldArr[this.clearfieldArr.length - 1].clearText || !this.clearfieldArr[this.clearfieldArr.length - 1].clearSymbol) {
          this.getMsg('请完善当前筛选条件信息');
          return;
        } else if (this.clearfieldArr[this.clearfieldArr.length - 1].typeInfo == 2) {
          if (!this.clearfieldArr[this.clearfieldArr.length - 1].clearText || !this.clearfieldArr[this.clearfieldArr.length - 1].clearSymbol || !this.clearfieldArr[this.clearfieldArr.length - 1].typeInfo || !this.clearfieldArr[this.clearfieldArr.length - 1].clearText2) {
            this.getMsg('请完善当前筛选条件信息');
            return;
          }
        }
      }
      this.clearfieldArr.push({
        clearText: '', clearText2: '', dataType: '', typeInfo: '', strList: [],
      })
    },
    delClearInput(idx) {
      if (this.clearfieldArr.length == 1) {
        this.getMsg('当前删选条件不可删除');
        return;
      }
      this.clearfieldArr.splice(idx, 1)
    },
    //新增一行
    addInput() {
      if (this.fieldArr[this.fieldArr.length - 1].celect != '不为空' && this.fieldArr[this.fieldArr.length - 1].celect != '为空') {
        if (!this.fieldArr[this.fieldArr.length - 1].fieldText || !this.fieldArr[this.fieldArr.length - 1].celect || !this.fieldArr[this.fieldArr.length - 1].fieldText2 || !this.fieldArr[this.fieldArr.length - 1].fieldText3) {
          this.getMsg('请完善当前条件添加信息');
          return;
        }
      } else if (this.fieldArr[this.fieldArr.length - 1].celect == '不为空' || this.fieldArr[this.fieldArr.length - 1].celect == '为空') {
        if (!this.fieldArr[this.fieldArr.length - 1].fieldText || !this.fieldArr[this.fieldArr.length - 1].celect || !this.fieldArr[this.fieldArr.length - 1].fieldText3) {
          this.getMsg('请完善当前条件添加信息');
          return;
        }
      }
      this.fieldArr.push({ fieldText: '', celect: '', fieldText2: '', fieldText3: '' })
    },
    changeAddInput() {
      if (!this.changeArr[this.changeArr.length - 1].fieldText || !this.changeArr[this.changeArr.length - 1].celect) {
        this.getMsg('请完善当前条件添加信息');
        return;
      }
      this.changeArr.push({ fieldText: '', celect: '' })
    },
    // 删除一行
    decInput(idx) {
      if (this.fieldArr.length == 1) {
        this.getMsg('当前删选条件不可删除');
        return;
      }
      this.fieldArr.splice(idx, 1)
    },
    changeDelInput(idx) {
      if (this.changeArr.length == 1) {
        this.getMsg('当前删选条件不可删除');
        return;
      }
      this.changeArr.splice(idx, 1)
    },
    changTypeSave() {
      if (!this.changeArr[this.changeArr.length - 1].fieldText || !this.changeArr[this.changeArr.length - 1].celect) {
        this.getMsg('请完善当前条件添加信息');
        return;
      } else {
        let data = {};
        //遍历fields参数的结果
        var arr = []
        var obj = {}
        for (var i = 0; i <= this.origData.tableProp.length - 1; i = i++) {
          obj = this.origData.tableProp[i].label
          arr.push(obj)
          i++;
        }
        let arrList = [];
        this.changeArr.forEach(item => {
          arrList.push({
            tbName: item.fieldText,//字段名
            tbType: 'CHAR',//运算符号
          })
        })
        for (let i in this.changeArr[this.changeArr.length - 1]) {
          data = {
            tableName: this.dataSet.origList[this.activeDataSet.orig].tableName,//当前表名 必须
            dataSourceID: this.dataSet.id,//当前数据接入ID 必须
            upTableType: arrList
          }
          UpTypes(data).then(res => {
            if (res.code === 200) {
              this.getMsg(res.message, 'success');
              this.getOrigTableList();
              this.changeArr = [
                {
                  fieldText: '',
                  celect: '',
                }
              ];
              this.change.dialog = false;
              GetFieldsInfo({
                dataSourceId: this.dataSet.id,
                tbName: this.dataSet.origList[this.activeDataSet.orig].tableName,
              }).then(res => {
                if (res.code === 200) {
                  this.downTableArr1 = [];
                  var i;
                  var downTableArr1 = []
                  for (i = 0; i < res.data.dataTabel.length; i++) {
                    downTableArr1.push(res.data.dataTabel[i].field)
                    this.getFieldsInfo = downTableArr1;
                  }
                }
              });
            }
          })
          return
        }
      }
    },
    resetTypeSave() {
      let data = {};
      var arr = []
      var obj = {}
      for (var i = 0; i <= this.origData.tableProp.length - 1; i = i++) {
        obj = this.origData.tableProp[i].label
        arr.push(obj)
        i++;
      }
      let arrList = [];
      this.changeArr.forEach(item => {
        arrList.push({
          tbName: item.fieldText,//字段名
          tbType: 'CHAR',//运算符号
        })
      })
      for (let i in this.changeArr[this.changeArr.length - 1]) {
        data = {
          tbName: this.dataSet.origList[this.activeDataSet.orig].tableName,//当前表名 必须
          dataSourceID: this.dataSet.id,//当前数据接入ID 必须
        }
        GetFieldsDele(data).then(res => {
          if (res.code === 200) {
            this.getMsg(res.message, 'success');
            this.getOrigTableList();
            this.changeArr = [
              {
                fieldText: '',
                celect: '',
              }
            ];
            this.change.dialog = false;
            GetFieldsInfo({
              dataSourceId: this.dataSet.id,
              tbName: this.dataSet.origList[this.activeDataSet.orig].tableName,
            }).then(res => {
              if (res.code === 200) {
                this.downTableArr1 = [];
                var i;
                var downTableArr1 = []
                for (i = 0; i < res.data.dataTabel.length; i++) {
                  downTableArr1.push(res.data.dataTabel[i].field)
                  this.getFieldsInfo = downTableArr1;
                }
              }
            });
          }
        })
        return
      }
    },
    //移除字段是否选中
    choose() {
      var arr = [];
      var str = document.getElementsByName("check");
      if (str.length > 0) {
        str = Array.from(str);
        str.forEach(function (input, index) {//也可以用for循环
          if (input.checked) {
            arr.push(input.value);//把选中数据放入数组
          }
        });
      }
      this.arr1 = arr;
    },
    //已经移除的字段是否选中
    choose2() {
      var arr = [];
      var str = document.getElementsByName("check2");
      if (str.length > 0) {
        str = Array.from(str);
        str.forEach(function (input, index) {//也可以用for循环
          if (input.checked) {
            arr.push(input.value);//把选中数据放入数组
          }
        });
      }
      this.arrHF = arr;
    },
    //合并展开字符算法
    unfoldStr() {
      var sub = document.getElementById("substr");
      var num = document.getElementById("number");
      var date = document.getElementById("datetime");
      var strBlue = document.getElementById("strLabel");
      var numBlue = document.getElementById("numLabel");
      var dateBlue = document.getElementById("dateLabel");
      var subList = document.getElementById("subList");
      var numList = document.getElementById("numList");
      var dateList = document.getElementById("dateList");
      var img1 = document.getElementById("img1");
      var img2 = document.getElementById("img2");
      var img3 = document.getElementById("img3");
      var img4 = document.getElementById("img4");
      var img5 = document.getElementById("img5");
      var img6 = document.getElementById("img6");
      if (sub.style.display == 'none') {
        sub.style.display = 'block';
        num.style.display = 'none';
        date.style.display = 'none';
        subList.style.display = 'block';
        numList.style.display = 'none';
        dateList.style.display = 'none';
        numBlue.style.color = '#666';
        dateBlue.style.color = '#666';
        strBlue.style.color = '#002774';
        img1.style.display = "none";
        img2.style.display = "inline-block";
        img3.style.display = "inline-block";
        img4.style.display = "none";
        img5.style.display = "inline-block";
        img6.style.display = "none";
      } else {
        sub.style.display = 'none';
        subList.style.display = 'none';
        strBlue.style.color = '#666';
        img1.style.display = "inline-block";
        img2.style.display = "none";
        img3.style.display = "inline-block";
        img4.style.display = "none";
        img5.style.display = "inline-block";
        img6.style.display = "none";
      }
    },
    unfoldNum() {
      var sub = document.getElementById("substr");
      var num = document.getElementById("number");
      var date = document.getElementById("datetime");
      var strBlue = document.getElementById("strLabel");
      var numBlue = document.getElementById("numLabel");
      var dateBlue = document.getElementById("dateLabel");
      var subList = document.getElementById("subList");
      var numList = document.getElementById("numList");
      var dateList = document.getElementById("dateList");
      var img1 = document.getElementById("img1");
      var img2 = document.getElementById("img2");
      var img3 = document.getElementById("img3");
      var img4 = document.getElementById("img4");
      if (num.style.display == 'none') {
        sub.style.display = 'none';
        num.style.display = 'block';
        date.style.display = 'none';
        subList.style.display = 'none';
        numList.style.display = 'block';
        dateList.style.display = 'none';
        strBlue.style.color = '#666';
        dateBlue.style.color = '#666';
        numBlue.style.color = '#002774'
        img1.style.display = "inline-block";
        img2.style.display = "none";
        img3.style.display = "none";
        img4.style.display = "inline-block";
        img5.style.display = "inline-block";
        img6.style.display = "none";
      } else {
        num.style.display = 'none';
        numList.style.display = 'none';
        numBlue.style.color = '#666';
        img1.style.display = "inline-block";
        img2.style.display = "none";
        img3.style.display = "inline-block";
        img4.style.display = "none";
        img5.style.display = "inline-block";
        img6.style.display = "none";
      }
    },
    unfoldDate() {
      var sub = document.getElementById("substr");
      var num = document.getElementById("number");
      var date = document.getElementById("datetime");
      var strBlue = document.getElementById("strLabel");
      var numBlue = document.getElementById("numLabel");
      var dateBlue = document.getElementById("dateLabel");
      var subList = document.getElementById("subList");
      var numList = document.getElementById("numList");
      var dateList = document.getElementById("dateList");
      if (date.style.display == 'none') {
        sub.style.display = 'none';
        num.style.display = 'none';
        date.style.display = 'block';
        subList.style.display = 'none';
        numList.style.display = 'none';
        dateList.style.display = 'block';
        strBlue.style.color = '#666';
        numBlue.style.color = '#666';
        dateBlue.style.color = '#002774'
        img1.style.display = "inline-block";
        img2.style.display = "none";
        img3.style.display = "inline-block";
        img4.style.display = "none";
        img5.style.display = "none";
        img6.style.display = "inline-block";
      } else {
        date.style.display = 'none';
        dateList.style.display = 'none';
        dateBlue.style.color = '#666';
        img1.style.display = "inline-block";
        img2.style.display = "none";
        img3.style.display = "inline-block";
        img4.style.display = "none";
        img5.style.display = "inline-block";
        img6.style.display = "none";
      }
    },
    changeClass(i) {
      if (this.fieldType.length) {
        if (!this.sqlText && this.tabFlag == '算法添加') {
          this.getMsg('请先选择右边的算法语句');
          return;
        }
        if (this.tabFlag == '算法添加') {
          this.sqlText = this.sqlText.split('字段名称').join(i.field)
        } else {
          this.fieldArr[this.fieldArr.length - 1].fieldText = i.field
        }
        this.Active = i;
      } else if (!this.origData.tableProp.length) {
        if (!this.sqlText && this.tabFlag == '算法添加') {
          this.getMsg('请先选择右边的算法语句');
          return;
        }
        if (this.tabFlag == '算法添加') {
          this.sqlText = this.sqlText.split('字段名称').join(i)
        } else {
          this.fieldArr[this.fieldArr.length - 1].fieldText = i
        }
        this.Active = i;
      }

    },
    changeType(i) {
      this.changeArr[this.changeArr.length - 1].fieldText = i.field
      this.Active = i;
    },
    SelectOne1(i) {
      this.changeArr[this.changeArr.length - 1].clearText2 = ''
      this.clearfieldArr[this.clearfieldArr.length - 1].dataType = timeList;
      this.Active = i;
    },
    SelectOne2(i) {
      this.clearfieldArr[this.clearfieldArr.length - 1].clearSymbol = i.clearSymbol;
      this.Active = i;

    },
    clearClass(i) {
      if (this.fieldType.length) {
        this.clearfieldArr[this.clearfieldArr.length - 1].clearText = i.field;
        this.clearfieldArr[this.clearfieldArr.length - 1].clearText2 = "";
        this.clearfieldArr[this.clearfieldArr.length - 1].clearSymbol = "";
        this.clearfieldArr[this.clearfieldArr.length - 1].dataType = '';
        this.Active = i;
        if (i.type == 0) {
          this.clearfieldArr[this.clearfieldArr.length - 1].typeInfo = 1;
          this.clearfieldArr[this.clearfieldArr.length - 1].strList = ["包含", "不包含", "等于", "不等于", "开头包含", "结尾包含", "不为空", "为空"]
        } else if (i.type == 1) {
          this.clearfieldArr[this.clearfieldArr.length - 1].typeInfo = 2;
          this.clearfieldArr[this.clearfieldArr.length - 1].dataType = '';
          this.clearfieldArr[this.clearfieldArr.length - 1].clearSymbol = '';
          this.clearfieldArr[this.clearfieldArr.length - 1].strList = ["区间", "等于", "不等于", "大于", "小于", "大于等于", "小于等于", "不为空", "为空"]
        } else if (i.type == 2) {
          this.clearfieldArr[this.clearfieldArr.length - 1].typeInfo = 3;
          this.clearfieldArr[this.clearfieldArr.length - 1].strList = ["等于", "不等于", "大于", "小于", "大于等于", "小于等于"]
        }
      } else if (!this.fieldType.length) {
        this.getMsg('当前表内该字段无数据，无法进行筛选');
        this.Active = i;
      }
    },
    delchangeClass(i) {
      this.Active = i;
    },
    tableListClass(index) {
      this.Active = index;
    },
    methodsColor(index, item) {
      this.num = index;
      // 将数据的sqlText赋值到中间
      this.sqlText = item.sqlText
    },
    tabsSwitch(tabIndex, tab) {
      this.addBtn = false;
      this.Active = -1;
      // var tabCardCollection = document.querySelectorAll(".tab-card"),  
      //     len = tabCardCollection.length;  
      // for(var i = 0; i < len; i++) {  
      //     tabCardCollection[i].style.display = "none";  
      //     this.tabsName[i].isActive = false;
      //     this.fieldName = '';  
      // }  
      // this.tabsName[tabIndex].isActive = true;  
      // tabCardCollection[tabIndex].style.display = "block";
      // this.fieldName = '';  

      this.tabsName = this.tabsName.map(i => {
        i.isActive = false
        return i
      });

      this.tabsName[tabIndex].isActive = true;

      // 记录目前是算法还是条件
      this.tabFlag = tab.name
      this.fieldName = "";
      this.sqlText = "";
      this.fieldArr = [
        {
          fieldText: '',
          celect: '',
          fieldText2: '',
          fieldText3: ''
        }
      ];
      this.otherwise = ""
    },
    //操作弹窗
    clearDialog(type) {
      if (type === 0) {
        this.helpPage = 1;
        GetFieldsInfo({
          dataSourceId: this.dataSet.id,
          tbName: this.dataSet.origList[this.activeDataSet.orig].tableName,
        }).then(res => {
          if (res.code === 200) {
            this.fieldType = res.data.dataTabel
          }
        });
        this.clear.dialog = true;
        this.clearfieldArr = [];

        if (this.alreadyTable.length == 0) {
          this.clearfieldArr = [
            {
              clearText: '',
              clearSymbol: '',
              clearText2: '',
            }
          ]
        } else {
          for (var i = 0; i < this.alreadyTable.length; i++) {
            var obj = {
              clearText: this.alreadyTable[i].fields,
              clearSymbol: this.alreadyTable[i].valType,
              clearText2: this.alreadyTable[i].val1,
            }
            this.clearfieldArr.push(obj)
          }
        }
      }
      else if (type === 1) {
        this.clear.dialog = false;
      }
    },
    changeDialog(type) {
      if (type === 0) {
        GetFieldsInfo({
          dataSourceId: this.dataSet.id,
          tbName: this.dataSet.origList[this.activeDataSet.orig].tableName,
        }).then(res => {
          if (res.code === 200) {
            this.fieldType = res.data.dataTabel
          }
        });
        this.change.dialog = true;
        GetFields({
          dataSourceId: this.dataSet.id,
          tbName: this.dataSet.origList[this.activeDataSet.orig].tableName,
        }).then(res => {
          if (res.code === 200) {
            if (res.data == 0) {
              this.changeTypeNum = false;
            } else {
              this.changeTypeNum = true;
            }
          }
        });
      }
      else if (type === 1) {
        this.change.dialog = false;
        // this.reload();//直接使用
        this.changeArr = [
          {
            fieldText: '',
            celect: '',
          }
        ];
      }
    },
    circleDialog(type) {
      if (type === 0) {
        this.circle.dialog = true;
      }
      else if (type === 1) {
        this.circle.dialog = false;
      }
    },
    tableDialog(type) {
      if (type === 0) {
        this.fortableName();
        this.associationName = "";
        this.arrList = [];
        this.helpPage = 2;
        this.table.dialog = true;
      }
      else if (type === 1) {
        this.table.dialog = false;
        this.associationName = "";
      }

    },
    addDialog(type) {
      if (type === 0) {
        GetFieldsInfo({
          dataSourceId: this.dataSet.id,
          tbName: this.dataSet.origList[this.activeDataSet.orig].tableName,
        }).then(res => {
          if (res.code === 200) {
            this.fieldType = res.data.dataTabel
          }
        });
        this.helpPage = 3;
        this.add.dialog = true;
        this.tabsSwitch(0, this.tabsName[0])
        this.addBtn = false;
      }
      else if (type === 1) {
        this.compileAdd = true;
        this.delMethods = true;
        this.add.dialog = false;
        // this.reload();//直接使用
        this.fieldName = "";
        this.sqlText = "";
        this.fieldArr = [
          {
            fieldText: '',
            celect: '',
            fieldText2: '',
            fieldText3: ''
          }
        ];
        this.otherwise = ""
      } else if (type === 2) {
        //展示已经新增了具体的哪些字段
      }

    },
    delDialog(type) {
      if (type === 0) {
        this.helpPage = 4;
        this.del.dialog = true;
        this.arr1 = []
        this.arr1 = []
        this.Active = '';
      }
      else if (type === 1) {
        this.del.dialog = false;
      }
    },
    //获取数据
    async init() {
      let id = this.getSession('view_source_xy') || '';
      if (id) {
        this.dataSet.id = id;
      } else {
        this.dataSet.id = '';
        this.getSoSet(0, '');
      }
      await this.dataSetDialogList();
      if (!this.dataSet.activeType.id) {
        return
      }
      await this.getDataSetNextALl();
    },
    //根据数据接入查询之后逻辑
    async getDataSetNextALl() {
      if (await this.getTestDataSet()) {
        await this.getComSZ();
        await this.getOrigTable();
        if (this.dataSet.activeType.type !== 0) {
          await this.getHistoryTable();
        }
        await this.getOrigTableList();
        await this.getDataSetBomList();
        await this.getDialogReset();
      } else {
        this.getLoadNoData();
      }
    },
    //公共操作
    getComSZ() {
      this.dataSetType = 0;
      $('.CodeMirror').remove();
      this.SQLText = null;
      this.activeDataSet = {
        orig: 0,
        SQL: -1
      };
    },
    //清空所有数据
    async getLoadNoData() {
      await this.getComSZ();
      this.dataSet.origList = [];
      this.dataSet.SQLList = [];
      this.origData.tableList = [];
      this.origData.tableProp = [];
      this.SQLData.tableList = [];
      this.SQLData.tableProp = [];
      this.dataSet.load = false;
      this.dataSetBom.load = false;
      this.origData.load = false;
      this.SQLData.load = false;
      this.origData.til = '';
      this.dataSetBom.list = [];
    },
    //测试是否可以连接数据接入
    async getTestDataSet() {
      let bool = false;
      this.allLoad = true;
      await GetConnByDataSource({
        dataSourceID: this.dataSet.id
      }).then(res => {
        if (res.code === 200) {
          bool = true;
        }
      }).catch(() => {
      });
      setTimeout(() => {
        this.allLoad = false;
      }, 300)
      return bool;
    },
    //sql编辑器
    getSQLText() {
      //编辑器
      let myTextarea = document.getElementById('codeSQL');
      this.SQLText = CodeMirror.fromTextArea(myTextarea, {
        mode: { name: "text/x-sql" },//编辑器语言
        theme: 'eclipse', //编辑器主题
        //extraKeys: {"Ctrl": "autocomplete"},//ctrl可以弹出选择项
        lineNumbers: true,//显示行号
      });
    },
    //切换类型
    getDataSetType(type) {
      if (type === this.dataSetType) {
        return;
      }
      this.dataSetType = type;
      $('.CodeMirror').remove();
      this.SQLText = null;
      // this.SQLData.tableList = []
      this.SQLData = {
        load: false,
        text: '',
        tableList: [],
        tableProp: []
      };
      if (this.dataSetType === 1) {
        this.$nextTick(() => {
          this.getSQLText();
        })
      }
    },
    /*- - - - - - - - - - 数据接入弹框 - - - - - - - - - - - - - - -*/
    //数据接入弹框
    async getDialog(type) {
      if (type === 0) {
        this.getDialogReset();
        this.dataSetDialog.show = true;
      } else if (type === 1) {
        this.dataSetDialog.show = false;
        await this.getDialogReset();
      } else if (type === 2) {
        this.dataSetDialog.show = false;
        if (this.dataSetDialog.id !== this.dataSet.id) {
          this.dataSet.id = this.dataSetDialog.id;
          await this.getDialogRadioChange();
          await this.getDialogReset();
          await this.getDataSetNextALl();
        }
      }
    },
    getHelp1(type) {
      if (type === 0) {
        this.help.dialog = true;
      }
      else if (type === 1) {
        this.help.dialog = false;
      }

    },
    //数据接入弹框 数据列表
    async dataSetDialogList() {
      this.allLoad = true;
      await GetDataSourceList().then(res => {
        if (res.code === 200) {
          this.dataSetDialog.typeList = res.data.dataTabel;
          if (this.dataSet.id) {
            this.getDialogRadioChange();
          } else {
            if (this.dataSetDialog.typeList.length) {
              let id = '';
              let count = 0;
              this.dataSetDialog.typeList.map(item => {
                if (count !== 0) {
                  return;
                }
                if (item.type === 1) {
                  id = item.id;
                  count = 1;
                }
              });
              if (count === 0) {
                this.dataSetDialog.typeList.map(item => {
                  if (count !== 0) {
                    return;
                  }
                  if (item.type === 2) {
                    id = item.id;
                    count = 1;
                  }
                });
              }
              if (count === 0) {
                this.dataSetDialog.typeList.map(item => {
                  if (count !== 0) {
                    return;
                  }
                  if (item.type === 3) {
                    id = item.id;
                    count = 1;
                  }
                });
              }
              if (count === 0) {
                this.dataSetDialog.typeList.map(item => {
                  if (count !== 0) {
                    return;

                  }
                  if (item.type === 0) {
                    id = item.id;
                    count = 1;
                  }
                });
              }
              this.dataSet.id = id;
              this.getDialogRadioChange();
            }
          }
        } else {
          this.dataSetDialog.typeList = [];
        }
      });
      setTimeout(() => {
        this.allLoad = false;
      }, 300)
    },
    //数据接入弹框 切换数据
    getDialogRadioChange() {
      this.dataSet.activeType = {};
      this.dataSetDialog.typeList.map((item) => {
        if (item.id === this.dataSet.id) {
          this.dataSet.activeType = item;
        }
      });
      this.getSoSet(0, this.dataSet.id);
    },
    //数据接入弹款 切换类型
    getDialogType(type) {
      if (type === this.dataSetDialog.type) {
        return;
      }
      this.dataSetDialog.type = type;
    },
    //数据接入弹款 重置
    getDialogReset() {
      this.dataSetDialog.id = this.dataSet.id;
      this.dataSetDialog.typeList.map((item) => {
        if (item.id === this.dataSetDialog.id) {
          this.dataSetDialog.type = item.type;
        }
      });
    },
    /*- - - - - - - - - - 原表导入 - - - - - - - - - - - - - - -*/
    //原表导入 数据
    async getOrigTable() {
      this.dataSet.load = true;
      await GetTableNameBySourceID({
        dataSourceID: this.dataSet.id
      }).then(res => {
        if (res.code === 200) {
          this.dataSet.origList = res.data.dataTabel || [];
          if (this.dataSet.origList.length) {
            this.activeDataSet.orig = 0;
            this.origData.til = this.dataSet.origList[0];
          }
          var tableAssociationList = []
          for (var i = 0; i < res.data.dataTabel.length; i++) {
            if (res.data.dataTabel[i].tableType === 1) {
              tableAssociationList.push(res.data.dataTabel[i].tableName);

            }
          }
          this.tableAssociationList = tableAssociationList;
          this.tableAssociationListLength = this.tableAssociationList.length;

          let result = this.dataSetDialog.typeList.find((result) => {
            return result.id == this.dataSet.id
          })
          this.sourceIdType = result.type;
        } else {
          this.dataSet.origList = [];
        }
      }).catch(() => {
      });
      setTimeout(() => {
        this.dataSet.load = false;
      }, 300)
    },
    //点击原表导入
    getOrigClick(index, item) {
      if (this.origData.til === item) {
        return;
      }
      this.activeDataSet.orig = index;
      this.origData.til = item;
      this.getOrigTableList();


      // GetFieldsInfo({
      //   dataSourceId: this.dataSet.id,
      //   tbName: this.dataSet.origList[this.activeDataSet.orig].tableName,
      // }).then(res => {
      //   if (res.code === 200) {
      //     this.downTableArr1 = [];
      //     var i;
      //     var downTableArr1 = []
      //     for (i = 0; i < res.data.dataTabel.length; i++) {
      //       downTableArr1.push(res.data.dataTabel[i].field)
      //       this.getFieldsInfo = downTableArr1;
      //     }
      //   }
      // });
    },
    //原表导入 数据表格
    getOrigTableList() {
      if (!this.dataSet.origList.length) {
        this.origData.tableProp = [];
        this.origData.tableList = [];
        this.origData.load = false;
        return;
      }
      this.origData.load = true;
      let tableName = this.dataSet.origList[this.activeDataSet.orig].tableName;
      GetInfoByTableName({
        tableName: tableName,
        dataSourceId: this.dataSet.id,
        pageIndex: this.tableData.pageIndex,
        pageSize: this.tableData.pageSize
      }).then(res => {
        if (res.code === 200) {
          this.origData.tableProp = [];
          if (res.data.dataTabel.length) {
            for (let i in res.data.dataTabel[0]) {
              this.origData.tableProp.push({
                label: i,
                prop: i
              })
            }
            this.origData.tableList = res.data.dataTabel;
            this.tableData.total = res.data.totalCount;

          } else {
            this.origData.tableProp = [];
            this.origData.tableList = [];
          }
        } else {
          this.origData.tableProp = [];
          this.origData.tableList = [];
        }
      }).catch(() => {
        this.origData.tableProp = [];
        this.origData.tableList = [];
      });


      //调用新数据扩充的数量的接口
      GetFieldCount({
        dataSourceId: this.dataSet.id,
        tbName: tableName,
      }).then(res => {
        if (res.code === 200) {
          this.addNum = res.data.addCount
          this.addName = res.data.addfields
          this.alreadyDel = res.data.delCount
          this.arrDelList = res.data.delfields
        }
      }).catch(() => { })

      // await GetDelFieldsInfo({
      //   dataSourceId: this.dataSet.id,
      //   tbName: this.dataSet.origList[this.activeDataSet.orig].tableName,
      // }).then(res => {
      //   if (res.code === 200) {
      //     this.alreadyDel = res.data.dataTabel.length
      //     this.arrDelList = res.data.dataTabel
      //   }
      // }).catch(() => { })


      GetFilterInfo({
        dataSourceId: this.dataSet.id,
        tbName: this.dataSet.origList[this.activeDataSet.orig].tableName,
      }).then(res => {
        if (res.code === 200) {
          this.alreadyScreen = res.data.dataTabel[0].fields;
          this.alreadyTable = res.data.dataTabel;
        }
      }).catch(() => { })
      setTimeout(() => {
        this.origData.load = false;
      }, 300)
    },
    //数据扩充，新增字段下拉框内容点击弹窗
    async clickDropdown(command) {
      this.delMethods = false;
      let tableName = this.dataSet.origList[this.activeDataSet.orig].tableName;
      await GetFieldinfo({
        dataSourceId: this.dataSet.id,
        tbName: tableName,
        fieldName: command,
      }).then(res => {
        if (res.code === 200) {
          if (res.data.functions) {
            this.fieldInfo = res.data.functions.functions;
            this.fieldAlias = res.data.functions.functionAlias;
            this.addDialog(0);
            this.fieldName = this.fieldAlias;
            this.sqlText = this.fieldInfo;
          } else if (res.data.caseWhen) {
            this.addDialog(0);
            this.tabsSwitch(1, true)
            this.tabFlag = '条件添加';
            this.fieldCaseAlias = res.data.caseWhen.caseAlias;
            this.fieldCaseElse = res.data.caseWhen.caseELSE;
            this.fieldCaseFields = res.data.caseWhen.caseFields;
            let response = JSON.parse(JSON.stringify(res.data.caseWhen.caseFields).replace(/field/g, 'fieldText').replace(/val/g, 'fieldText2').replace(/resultVal/g, 'fieldText3').replace(/ifType/g, 'celect'));
            this.fieldArr = response,
              this.fieldName = this.fieldCaseAlias;
            this.otherwise = this.fieldCaseElse;
          }
        }
      }).catch(() => { })
    },
    /*- - - - - - - - - - SQL - - - - - - - - - - - - - - -*/
    //历史SQL数据
    async getHistoryTable() {
      this.dataSet.load = true;
      await GetSqlListByUser({
        dataSourceID: this.dataSet.id
      }).then(res => {
        if (res.code === 200) {
          this.dataSet.SQLList = res.data.dataTabel;
        } else {
          this.dataSet.SQLList = [];
        }
      }).catch(() => {
      });
      setTimeout(() => {
        this.dataSet.load = false;
      }, 300)
    },

    //点击SQL
    getSQLClick(index) {
      this.activeDataSet.SQL = index;
      this.SQLData.text = this.dataSet.SQLList[this.activeDataSet.SQL];
      this.SQLText.setValue(this.SQLData.text);
    },
    //添加SQL的数据
    async getSQLValue(type, page) {
      if (type === 1) {
        this.SQLData.text = this.SQLText.getValue();
        if (!this.SQLData.text) {
          this.getMsg('请输入SQL进行执行');
          return;
        }
      }
      let bool = false;
      this.SQLData.load = true;
      await GetInfoBySql({
        sql: this.SQLData.text,
        dataSourceId: this.dataSet.id
      }).then(async res => {
        if (res.code === 200) {
          this.SQLData.tableProp = [];
          if (res.data.dataTabel.length) {
            for (let i in res.data.dataTabel[0]) {
              this.SQLData.tableProp.push({
                label: i,
                prop: i
              })
            }
            this.SQLData.tableList = res.data.dataTabel;
          } else {
            this.SQLData.tableProp = [];
            this.SQLData.tableList = [];
          }
          if (type === 1) {
            await this.getHistoryTable();
            this.activeDataSet.SQL = 0;
          }
          bool = true;
        } else {
          this.SQLData.tableProp = [];
          this.SQLData.tableList = [];
        }
      }).catch(() => {
        this.SQLData.tableProp = [];
        this.SQLData.tableList = [];
      });
      setTimeout(() => {
        this.SQLData.load = false;
      }, 300);
      if (page === 2) {
        return bool;
      }
    },
    /*- - - - - - - - - - 数据准备列表 - - - - - - - - - - - - - - -*/
    //数据准备列表
    async getDataSetBomList() {
      this.dataSetBom.load = true;
      await GetDataSetList({
        pageIndex: 1,
        pageSize: 9999,
        dataSourceID: this.dataSet.id,
      }).then(res => {
        if (res.code === 200) {
          if (res.data) {
            this.dataSetBom.list = res.data.dataTabel;
          } else {
            this.dataSetBom.list = [];
          }
        } else {
          this.dataSetBom.list = [];
        }
      }).catch(() => {
      });
      setTimeout(() => {
        this.dataSetBom.load = false;
      }, 300)
    },

    //删除数据准备
    getBomReomve(item) {
      this.$alert('您确定要删除【' + item.dataSetName + '】吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: true,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        customClass: 'alert_allCom',
      }).then(() => {
        RemoveDataSet({
          ids: item.id
        }).then(res => {
          if (res.code === 200) {
            this.getMsg(res.message, 'success');
            this.getDataSetBomList();
          }
        })
      }).catch(() => {

      })
    },
    //数据准备名称
    async getNameRepeat(name) {
      let bool = false;
      await GetDataSetNameVerify({
        dataSetName: name,
        dataSourceID: this.dataSet.id
      }).then(res => {
        if (res.code === 200) {
          bool = true;
        }
      });
      return bool;
    },
    //保存 名称
    async getSaveName(type) {
      if (type === 0) {
        if (!this.dataSet.origList[this.activeDataSet.orig].tableName) {
          this.getMsg('请选择原表进行保存');
          return;
        }
      } else if (type === 1) {
        this.SQLData.text = this.SQLText.getValue();
        if (!this.SQLData.text) {
          this.getMsg('请输入SQL进行保存');
          return;
        }
        if (!await this.getSQLValue(1, 2)) {
          return;
        }
      }
      this.$prompt('数据准备名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnPressEscape: false,
        closeOnClickModal: false,
        customClass: 'alert_allCom',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            if (!instance.inputValue) {
              this.getMsg('请输入数据准备名称');
            } else {
              if (await this.getNameRepeat(instance.inputValue)) {
                done();
              }
            }
            return false;
          } else {
            done();
          }
        }
      }).then(({ value }) => {
        this.getSave(type, value);
      }).catch(() => {

      });
    },
    //保存
    getSave(type, value) {
      let data = {};
      if (type === 0) {
        if (this.dataSetDialog.type !== 0) {
          data = {
            dataSetName: value,
            dataSourceID: this.dataSet.id,
            tableName: this.dataSet.origList[this.activeDataSet.orig].tableName,
          }
        } else {
          data = {
            dataSetName: value,
            dataSourceID: this.dataSet.id,
            sheetName: this.dataSet.origList[this.activeDataSet.orig].tableName,
          }
        }
      } else if (type === 1) {
        data = {
          dataSetName: value,
          dataSourceID: this.dataSet.id,
          sqlText: this.SQLData.text,
        }
      }
      SaveDataSet(data).then(res => {
        if (res.code === 200) {
          this.getMsg(res.message, 'success');
          this.getDataSetBomList();
        }
      })
    },
    //跳转下一页
    getBomRoute(item) {
      this.getSoSet(1, item.id);
      this.$router.push('viewSet');
    },

    // 数据关联
    handleOpen() {
      this.arrow = "el-icon-caret-bottom";
    },
    handleClose() {
      this.arrow = "el-icon-caret-right";
    },
    flowNodeClick(meta) {
    },
    linkStyle(link) {
      return {
        // hover: '#CAE7E9'
      };
    },
    linkDesc(link) {
      return link.meta ? link.meta.desc : "请右键编辑关联关系";
    },
    settingSubmit() {
      const conf = this.drawerConf;
      if (this.drawerConf.type === drawerType.node) {
        if (!conf.info.meta) conf.info.meta = {};
        Object.keys(this.nodeSetting).forEach((key) => {
          this.$set(conf.info.meta, key, this.nodeSetting[key]);
        });
        // this.$refs.nodeSetting.resetFields();
      } else {
        if (!conf.info.meta) conf.info.meta = {};
        Object.keys(this.linkSetting).forEach((key) => {
          this.$set(conf.info.meta, key, this.linkSetting[key]);
        });
        // this.$refs.linkSetting.resetFields();
      }

      if (this.linkSetting.desc == "左关联") {
        var states = 0;
      } else if (this.linkSetting.desc == "右关联") {
        var states = 1;
      } else if (this.linkSetting.desc == "内关联") {
        var states = 2;
      } else if (this.linkSetting.desc == "全关联") {
        var states = 5;
      }

      let showFalse = true;
      this.arrList.forEach(item => {
        if (item.mainName === this.startTab && item.fromName === this.endTab) {
          showFalse = false;
          item.joinType = states;
          item.mainJoinField = this.linkSetting.startTabField;
          item.fromJoinField = this.linkSetting.endTabField;
        }
      })
      if (showFalse) {
        this.arrList.push({
          mainName: this.startTab,
          mainJoinField: this.linkSetting.startTabField,
          joinType: states,
          fromName: this.endTab,
          fromJoinField: this.linkSetting.endTabField,
        })
      }
      conf.visible = false;
    },
    nodeClick() {
    },

    docMousemove({ clientX, clientY }) {
      const conf = this.dragConf;

      if (conf.isMove) {
        conf.ele.style.top = clientY - conf.offsetTop + "px";
        conf.ele.style.left = clientX - conf.offsetLeft + "px";
      } else if (conf.isDown) {
        // 鼠标移动量大于 5 时 移动状态生效
        conf.isMove =
          Math.abs(clientX - conf.clientX) > 5 ||
          Math.abs(clientY - conf.clientY) > 5;
      }
    },

    docMouseup({ clientX, clientY }) {
      const conf = this.dragConf;
      conf.isDown = false;

      if (conf.isMove) {
        const {
          top,
          right,
          bottom,
          left,
        } = this.$refs.flowContainer.getBoundingClientRect();

        // 判断鼠标是否进入 flow container
        if (
          clientX > left &&
          clientX < right &&
          clientY > top &&
          clientY < bottom
        ) {
          // 获取拖动元素左上角相对 super flow 区域原点坐标
          const coordinate = this.$refs.superFlow.getMouseCoordinate(
            clientX - conf.offsetLeft,
            clientY - conf.offsetTop
          );

          // 添加节点
          this.$refs.superFlow.addNode({
            coordinate,
            ...conf.info,
          });
        }

        conf.isMove = false;
      }

      if (conf.ele) {
        conf.ele.remove();
        conf.ele = null;
      }
    },

    nodeItemMouseDown(evt, info) {
      const { clientX, clientY, currentTarget } = evt;

      const { top, left } = evt.currentTarget.getBoundingClientRect();

      const conf = this.dragConf;
      const ele = currentTarget.cloneNode(true);

      Object.assign(this.dragConf, {
        offsetLeft: clientX - left,
        offsetTop: clientY - top,
        clientX: clientX,
        clientY: clientY,
        info,
        ele,
        isDown: true,
      });

      ele.style.position = "fixed";
      ele.style.margin = "0";
      ele.style.top = clientY - conf.offsetTop + "px";
      ele.style.left = clientX - conf.offsetLeft + "px";

      this.$el.appendChild(this.dragConf.ele);
    },
  },
  mounted() {
    this.init();
    // ====数据关联=====
    document.addEventListener("mousemove", this.docMousemove);
    document.addEventListener("mouseup", this.docMouseup);
    this.$once("hook:beforeDestroy", () => {
      document.removeEventListener("mousemove", this.docMousemove);
      document.removeEventListener("mouseup", this.docMouseup);
    });
  },
  destroyed() {

  }
}
</script>

<style lang="less">
@borderRadio: 5px;
@borderColor: #ccc;
@shadow: 0 0 15px @h_top_backColor;
//普通字体
@SQL_color: #111;
@SQL_orange: #ec6941;
@SQL_green: #13b5b1;
@SQL_blue: #557dec;
@SQL_backColor: #f6f6f6;
@SQL_borderColor: #ddd;
@SQL_th_borderColor: #ddd;
@SQL_th_backColor: #f0f0f0;
@SQL_fontSize: 14px;
.sjj {
  display: grid;
  grid-template-columns: 230px auto;
}

.el-dialog {
  .details_dialog_form {
    padding: 10px 0;
    position: relative;

    .el-form {
      width: 100%;
      height: 100%;
      padding: 20px 0 20px 0;
    }

    .btnRight {
      text-align: center;
      margin-top: 15px;
    }
  }
  .changeBox {
    height: 600px;
    background: #fff;
    .bottomBox {
      width: 100%;
      height: 100px;
      float: left;
      position: relative;
      .changeTypeBtn {
        width: 104px;
        height: 32px;
        background: #39ae78;
        border-radius: 5px;
        position: absolute;
        bottom: 30px;
        right: 30px;
        color: #fff;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        cursor: pointer;
      }
      .changeTypeBtn2 {
        width: 104px;
        height: 32px;
        background: #39ae78;
        border-radius: 5px;
        position: absolute;
        bottom: 30px;
        right: 150px;
        color: #fff;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        cursor: pointer;
      }
    }
  }
  .changeLeft::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  .changeLeft::-webkit-scrollbar-track {
    border-radius: 10px;
  }
  .changeLeft::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #d2d2d2;
  }
  .changeLeft {
    width: 280px;
    min-height: 500px;
    max-height: 500px;
    float: left;
    border-radius: 10px 0 0 10px;
    background: #f5f5f5;
    // border-radius: 10px;
    padding: 17px 0;
    overflow-y: scroll;
    overflow-x: hidden;
    .field {
      width: 240px;
      height: 40px;
      line-height: 40px;
      // text-align: center;
      padding-left: 20%;
      font-size: 20px;
      // font-weight: bold;
      position: relative;
      color: #666;
      cursor: pointer;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
    }
    .field_center {
      height: 40px;
      line-height: 40px;
      text-align: left;
      padding-left: 30%;
      font-size: 20px;
      position: relative;
      color: #666;
      margin-top: 200px;
    }
    .active {
      border-radius: 5px;
      background: #002774;
      color: #fff;
    }
  }
  .tab-card2::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  .tab-card2::-webkit-scrollbar-track {
    border-radius: 10px;
  }
  .tab-card2::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #d2d2d2;
  }
  .tab-card2 {
    // display: none;
    float: left;
    width: 800px;
    height: 500px;
    background: #e5e5e5;
    border-radius: 0 10px 10px 0;
    overflow-y: scroll;
    position: relative;
    .new {
      padding: 30px 50px;
      font-size: 14px;
      box-sizing: border-box;
      background: #e5e5e5;
      border: none;
      outline: none;
    }
    .conditions {
      padding: 30px 50px;
      font-size: 0;

      span {
        font-size: 16px;
        color: #666;
      }
      .input2 {
        width: 100px;
        height: 50px;
        border-radius: 10px;
        text-align: center;
        margin-left: 30px;
        margin-right: 30px;
        outline: none;
      }
      .input2:focus {
        box-shadow: 0 0 10px 0 skyblue;
      }
      .input2:nth-child(4) {
        margin: 0 30px;
      }
      .select2 {
        width: 50px;
        height: 50px;
        border-radius: 10px;
        border: none;
        text-align: center;
        margin-left: 30px;
        margin-right: 30px;
        outline: none;
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
      }
      .select2:focus {
        box-shadow: 0 0 10px 0 skyblue;
      }
      option {
        background-color: rgba(0, 0, 0, 0.5);
        color: #fff;
      }
      .circleBtn {
        width: 80px;
        height: 50px;
        display: inline-block;
        vertical-align: middle;
        margin-left: 50px;
        float: right;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .circleAdd,
      .circleDel {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        text-align: center;
        line-height: 20px;
        font-size: 30px;
        cursor: pointer;
      }
      .circleAdd:active {
        border-color: rgba(0, 206, 83, 0.5);
        color: rgba(0, 206, 83, 0.5);
      }
      .circleAdd {
        border: 2px solid #00ce53;
        color: #00ce53;
      }
      .circleDel:active {
        border-color: rgba(255, 18, 64, 0.5);
        color: rgba(255, 18, 64, 0.5);
      }
      .circleDel {
        border: 2px solid #ff1240;
        color: #ff1240;
      }
      .judge {
        margin-bottom: 30px;
        .null {
          margin-right: 160px;
        }
      }
    }
  }
}

.del {
  height: 650px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  position: relative;
  .help {
    position: absolute;
    right: 0px;
    top: 0px;
    cursor: pointer;
  }
  .jian1 {
    width: 64px;
    height: 45px;
    position: absolute;
    top: 270px;
    left: 303px;
    background-image: url("../../../../assets/common/image/gray1.png");
  }
  .jian1:active {
    background-image: url("../../../../assets/common/image/blue1.png");
  }
  .jian2 {
    width: 64px;
    height: 45px;
    position: absolute;
    top: 320px;
    left: 303px;
    background-image: url("../../../../assets/common/image/gray2.png");
  }
  .jian2:active {
    background-image: url("../../../../assets/common/image/blue2.png");
  }
  .tit {
    width: 100%;
    padding: 10px 0;
    font-size: 22px;
    text-align: center;
    background: #fff;
  }
  .content {
    width: 100%;
    height: 100%;
    background: #f5f5f5;
    border-radius: 10px;
    padding: 10px 0;
    overflow-y: scroll;
    overflow-x: hidden;
    .field,
    .field_right {
      width: 240px;
      height: 40px;
      line-height: 40px;
      font-size: 20px;
      text-align: left;
      position: relative;
      color: #666;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
    }
    .field_center,
    .field_right_center {
      margin-top: 200px;
      margin-left: 80px;
    }
    .field_right {
      padding-left: 0%;
      text-align: center;
    }
    .active {
      color: #fff;
      background-color: #002774;
      border-radius: 5px;
    }
    // .active::after{
    //     position: absolute;
    //     bottom: -10px;
    //     right: 0px;
    //     height: 30px;
    //     width: 4px;
    //     height: 60px;
    //     border-radius: 10px;
    //     content: '';
    //     -webkit-transform: scaleY(.5);
    //     background-color: #d2d2d2;
    //     // background-color: #002774;
    // }
    input {
      margin: 0 30px 0 30px;
    }
  }
  .content::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  /*定义滚动条轨道 内阴影+圆角*/
  .content::-webkit-scrollbar-track {
    border-radius: 10px;
  }

  /*定义滑块 内阴影+圆角*/
  .content::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #d2d2d2;
  }
}
.del_left {
  width: 250px;
  height: 590px;
  img {
    vertical-align: -3px;
    margin-left: 10px;
  }
}
.del_right {
  width: 250px;
  height: 590px;
  img {
    vertical-align: -3px;
    margin-left: 10px;
  }
}
.bottom_btn {
  position: absolute;
  bottom: 30px;
  right: 30px;
  .FBtn {
    margin: 0 20px;
  }
}

.dataSet {
  overflow: hidden;
  width: 99%;
  margin-right: 1%;
  background-color: #eaebf7;
  border-radius: 10px;
  padding-bottom: 20px;

  .leftSet {
    width: 16%;
    height: 100%;
    // margin-right: 1%;
    float: left;
    display: inline-block;
    background: #eaebf7;
    padding: 20px;

    .leftTil {
      background-color: @h_path_backColor;
      padding: 2px 5px;
      line-height: 30px;
      position: relative;
      box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      .noSelect;

      .FSpanTil {
        vertical-align: middle;
        max-width: 80%;

        .div_svg {
          margin-top: 0;
        }
      }

      .divSvg {
        display: inline-block;
        float: right;
        width: 30px;
        height: 30px;
        margin-top: 1px;
      }
    }

    .leftList {
      margin-top: 15px;
      margin-bottom: 15px;
      display: inline-block;
      width: 100%;
      // height: calc(100% - 30% - 15px - 30px - 14px - 15px);
      background-color: @h_path_backColor;
      // border-radius: @borderRadio;
      box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
      border-radius: 10px;

      .list_til {
        width: 100%;
        height: 40px;
        line-height: 40px;
        border-top-left-radius: @borderRadio;
        white-space: normal;
        // border-bottom: 1px solid @borderColor;

        .addDivSpan {
          // background-color: hsl(@green, 90%) !important;
          color: #002774 !important;
          position: relative;
        }
        .addDivSpan::after {
          position: absolute;
          bottom: 3px;
          left: 20px;
          right: 20px;
          height: 5px;
          content: "";
          -webkit-transform: scaleY(0.5);
          transform: scaleY(0.5);
          background-color: #0c0c54;
        }

        .divSpan {
          cursor: pointer;
          color: #666;
          display: inline-block;
          float: left;
          font-size: 16px;
          width: 50%;
          text-align: center;
          letter-spacing: 1px;
          .text_oneLine;
        }

        .divSpan:first-child {
          border-top-left-radius: @borderRadio;
        }

        .divSpan:last-child {
          border-top-right-radius: @borderRadio;
        }

        .oneDivSpan {
          width: 100%;
          background-color: hsl(@green, 90%) !important;
          color: #fff !important;
          border-top-left-radius: @borderRadio;
          border-top-right-radius: @borderRadio;
        }

        .divSpan:hover {
          background-color: hsl(@green, 15%);
        }
      }

      .listUl_count {
        width: 100%;
        height: calc(100% - 40px);
        overflow-y: auto;
        overflow-x: hidden;

        .listUl {
          width: 100%;
          height: 508px;

          > li {
            width: 100%;
            line-height: 40px;
            padding: 0 10px;
            color: #999;
            font-size: 14px;
            cursor: pointer;
            letter-spacing: 1px;
            .text_oneLine;
          }

          > li:hover {
            // background-color: hsl(@green, 10%);
            background: rgba(0, 39, 116, 0.3);
            color: #fff;
          }

          .addValList {
            // background-color: hsl(@green, 30%) !important;
            // border-left: 1px solid #000;
            position: relative;
          }
          .addValList::after {
            position: absolute;
            bottom: 4px;
            left: 0px;
            height: 30px;
            width: 2px;
            content: "";
            -webkit-transform: scaleY(0.5);
            background-color: #0c0c54;
          }
        }
      }
      .listUl_count::-webkit-scrollbar {
        width: 4px;
        height: 4px;
      }
      /*定义滚动条轨道 内阴影+圆角*/
      .listUl_count::-webkit-scrollbar-track {
        border-radius: 10px;
      }

      /*定义滑块 内阴影+圆角*/
      .listUl_count::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #d2d2d2;
      }
    }

    .leftBomList {
      display: inline-block;
      width: 100%;
      height: 30%;
      // background-color: @h_path_backColor;
      border-radius: @borderRadio;

      .list_til {
        width: 100%;
        height: 40px;
        line-height: 40px;
        border-top-left-radius: @borderRadio;
        white-space: normal;
        // border-bottom: 1px solid @borderColor;

        .FSpanTil {
          height: 40px;
          // background-color: hsl(@green, 90%) !important;
          border-top-left-radius: @borderRadio;
          border-top-right-radius: @borderRadio;
          color: #fff !important;
          text-align: left;
          .div_svg {
            margin-top: 0;

            svg {
              path {
                fill: #fff;
              }
            }
          }
        }
      }

      .listUl_count {
        width: 100%;
        // height: calc(100% - 40px);
        overflow-y: auto;
        overflow-x: hidden;
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);

        .listUl {
          width: 100%;
          height: 100%;

          > li {
            width: 100%;
            line-height: 40px;
            padding: 0 10px;
            color: hsl(@fontColor, 0.8);
            font-size: 16px;
            cursor: pointer;
            letter-spacing: 1px;
            .text_oneLine;
            height: 40px;
            border-bottom: 1px solid #e5e5e5;

            > span {
              display: inline-block;
              width: calc(100% - 70px);
              height: 100%;
              line-height: 40px;
              .text_oneLine;
              float: left;
            }

            .FSvg {
              margin-right: 12px;
              margin-top: -2px;
              float: left;
              cursor: pointer;
            }

            .FSvg:last-child {
              margin-right: 0;
            }
          }

          > li:last-child(1) {
            border-bottom: none;
          }

          > li:hover {
            background-color: hsl(@green, 10%);
          }

          .addValList {
            background-color: hsl(@green, 30%) !important;
          }
        }
      }
    }
  }

  .rigSet {
    // background-color: @h_path_backColor;
    border-radius: @borderRadio;
    height: 100%;
    width: 83%;
    float: left;
    display: inline-block;
    padding: 5px 5px;

    > .type_0 {
      width: 100%;
      height: 100%;

      > .rigTil {
        // line-height: 30px;
        padding: 0px 15px;
        display: inline-block;
        width: 100%;
        height: 65px;
        .FBtn {
          float: right;
          margin: 20px;
        }

        > div {
          display: inline-block;
          float: left;
          vertical-align: middle;
          margin-top: -2px;
        }

        > span {
          display: inline-block;
          margin-left: 10px;
          color: @fontColor;
          float: left;
          font-size: 20px;
          letter-spacing: 2px;
          width: calc(100% - 100px);
          .text_oneLine;
        }
      }

      > .rigCount {
        width: 100%;
        // height: calc(100% - 50px);
        // padding: 15px;
        overflow-y: auto;
        overflow-x: hidden;
        box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
        background: #fff;
        border-radius: 10px;

        .rigCount_div {
          width: 100%;
          // height: 100%;
          position: relative;
          overflow-y: hidden;
          .el-table {
            height: calc(100% - 50px);
          }
        }
      }
      .FPage {
        width: 90%;
        margin-top: 20px;
      }
      .FBtn {
        text-align: right;
        margin-top: 25px;
      }
    }

    > .type_1 {
      width: 100%;
      height: 100%;

      .type_1_sql {
        width: 100%;
        // height: 40%;
        padding: 20px 20px 0;

        > .CodeMirror {
          height: calc(100% - 50px);
          margin-bottom: 10px;
          border: 2px solid @SQL_borderColor;
          border-top: 3px solid @green;
          background: @SQL_backColor;
          color: @SQL_color;
          font-size: @SQL_fontSize;
          letter-spacing: 1px;

          .CodeMirror-code {
            line-height: 25px;
          }

          .CodeMirror-gutters {
            background: @SQL_th_backColor;
            color: hsl(@SQL_color, 80%);
            border-right: 2px solid @SQL_th_borderColor;
          }

          .cm-bracket {
            color: @SQL_green;
            margin: 0 2px;
          }

          span.cm-keyword {
            color: @SQL_orange;
          }

          span.cm-string {
            color: @SQL_blue;
          }
        }

        > .btn_div {
          height: 40px;
          line-height: 40px;
          text-align: right;
        }
      }

      .type_1_table {
        width: 100%;
        // height: 60%;

        > .rigTil {
          line-height: 30px;
          padding: 10px 15px 0;
          display: inline-block;
          width: 100%;

          > div {
            display: inline-block;
            float: left;
            vertical-align: middle;
            margin-top: -2px;
          }

          > span {
            display: inline-block;
            margin-left: 10px;
            color: @fontColor;
            float: left;
            font-size: 20px;
            letter-spacing: 2px;
            width: calc(100% - 100px);
            .text_oneLine;
          }
        }

        > .rigCount {
          width: 100%;
          height: calc(100% - 50px);
          padding: 15px;
          overflow-y: auto;
          overflow-x: hidden;

          .rigCount_div {
            width: 100%;
            height: 100%;
            position: relative;

            .el-table {
              // height: calc(100% - 50px);
            }
            .FBtn {
              float: right;
              margin-top: 15px;
            }
          }
        }
      }
    }
  }

  .dataSet_dialog {
    .el-dialog {
      height: 65%;
    }

    .el-dialog__body {
      padding: 0;

      .dataSet_dialog_count {
        padding: 5px 20px;
        width: 100%;
        height: 100%;

        .type_radio {
          margin: 10px 20px;
          display: inline-block;
          width: calc(100% - 40px);
          text-align: center;
          border-bottom: 2px solid #ddd;
          height: 40px;

          > span {
            line-height: 35px;
            float: left;
            // margin-right: 20px;
            font-size: 14px;
            letter-spacing: 1px;
            color: #a3a3a3;
            cursor: pointer;
            padding: 0 10px;
            text-align: left;
            .noSelect;
            font-weight: bold;
            border-bottom: 2px solid transparent;
            margin-top: 2px;
          }

          > span:hover {
            color: @green;
            font-weight: bold;
            border-bottom: 2px solid @green;
          }

          .addSpan {
            color: @green;
            font-weight: bold;
            border-bottom: 2px solid @green;
          }
        }

        .div_radio {
          padding: 0 30px;
          height: calc(100% - 110px);
          overflow-y: auto;

          .el-radio-group {
            width: 100%;

            .el-radio {
              width: 100%;
              line-height: 40px;
              margin-right: 0 !important;

              .el-radio__inner {
                width: 18px;
                height: 18px;
              }

              .el-radio__label {
                font-size: 18px;
                width: calc(100% - 50px);
                .text_oneLine;
                display: inline-block;
                vertical-align: middle;
                margin-left: 5px;
              }

              .el-radio__inner::after {
                width: 6px;
                height: 6px;
              }
            }
          }
        }

        .div_btn {
          padding: 10px;
          display: inline-block;
          width: 100%;
          text-align: right;
        }
      }
    }
  }
}
.addData {
  width: 1140px;
  height: 800px;
  .help {
    position: absolute;
    right: 5px;
    top: 65px;
    cursor: pointer;
  }
  .top {
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    .fieldName {
      input {
        border-bottom: 1px solid #000;
        text-align: center;
        outline: none;
      }
    }
  }
  .middle {
    height: 590px;
    display: flex;
    justify-content: space-between;
    .left {
      width: 250px;
      border-radius: 10px 0 0 10px;
      background: #f5f5f5;
      // border-radius: 10px;
      padding: 17px 0;
      overflow-y: scroll;
      .field {
        width: 240px;
        height: 40px;
        line-height: 40px;
        // text-align: center;
        padding-left: 20%;
        font-size: 20px;
        // font-weight: bold;
        position: relative;
        color: #666;
        cursor: pointer;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
      .field_center {
        height: 40px;
        line-height: 40px;
        text-align: left;
        padding-left: 30%;
        font-size: 20px;
        position: relative;
        color: #666;
        margin-top: 200px;
      }
      // .field:hover{
      //     color: #002774;
      //     background: #0C0C54;
      //     color: #fff;
      // }
      .active {
        border-radius: 5px;
        background: #002774;
        color: #fff;
      }
      // .active::after{
      //     position: absolute;
      //     bottom: -10px;
      //     right: 0px;
      //     height: 30px;
      //     width: 4px;
      //     height: 60px;
      //     border-radius: 10px;
      //     content: '';
      //     -webkit-transform: scaleY(.5);
      //     background-color: #d2d2d2;
      // }
    }
    /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
    .left::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    /*定义滚动条轨道 内阴影+圆角*/
    .left::-webkit-scrollbar-track {
      border-radius: 10px;
    }

    /*定义滑块 内阴影+圆角*/
    .left::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #d2d2d2;
    }
    .tab-card {
      // display: none;
      width: 860px;
      background: #e5e5e5;
      border-radius: 0 10px 10px 0;
      overflow-y: hidden;
      position: relative;
      .new {
        padding: 30px 50px;
        font-size: 14px;
        box-sizing: border-box;
        background: #e5e5e5;
        border: none;
        outline: none;
      }
      .conditions {
        padding: 30px 50px;
        font-size: 0;

        span {
          font-size: 16px;
          color: #666;
        }
        input {
          width: 100px;
          height: 50px;
          border-radius: 10px;
          text-align: center;
          margin-left: 30px;
          outline: none;
        }
        input:focus {
          box-shadow: 0 0 10px 0 skyblue;
        }
        input:nth-child(4) {
          margin: 0 30px;
        }
        select {
          width: 50px;
          height: 50px;
          border-radius: 10px;
          border: none;
          text-align: center;
          margin-left: 30px;
          outline: none;
          appearance: none;
          -moz-appearance: none;
          -webkit-appearance: none;
        }
        select:focus {
          box-shadow: 0 0 10px 0 skyblue;
        }
        option {
          background-color: rgba(0, 0, 0, 0.5);
          color: #fff;
        }
        .circleBtn {
          width: 80px;
          height: 50px;
          display: inline-block;
          vertical-align: middle;
          margin-left: 50px;
          float: right;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .circleAdd,
        .circleDel {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          text-align: center;
          line-height: 20px;
          font-size: 30px;
          cursor: pointer;
        }
        .circleAdd:active {
          border-color: rgba(0, 206, 83, 0.5);
          color: rgba(0, 206, 83, 0.5);
        }
        .circleAdd {
          border: 2px solid #00ce53;
          color: #00ce53;
        }
        .circleDel:active {
          border-color: rgba(255, 18, 64, 0.5);
          color: rgba(255, 18, 64, 0.5);
        }
        .circleDel {
          border: 2px solid #ff1240;
          color: #ff1240;
        }
        .judge {
          margin-bottom: 30px;
          .null {
            margin-right: 160px;
          }
        }
      }
      .end {
        padding-left: 50px;
        font-size: 16px;
        color: #666;
        padding-bottom: 30px;
        input {
          width: 100px;
          height: 50px;
          border-radius: 10px;
          text-align: center;
          margin-left: 396px;
          outline: none;
        }
        input:focus {
          box-shadow: 0 0 10px 0 skyblue;
        }
        input:nth-child(4) {
          margin: 0 30px;
        }
      }
      .center {
        width: 580px;
        height: 100%;
        background: #e5e5e5;
        border-radius: 10px 0 0 10px;
        font-size: 16px;
        float: left;
        position: relative;
        .FBtn {
          position: absolute;
          bottom: 30px;
          right: 30px;
        }
        .new {
          width: 100%;
          height: 100%;
          padding: 30px 50px;
          font-size: 14px;
          position: relative;
          border-radius: 10px;
          line-height: 30px;
          font-size: 16px;
          .for {
            min-height: 60px;
            padding: 10px;
            background: #fff;
            box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
            border-radius: 10px;
            margin: 10px 0;
            .div_for {
              display: inline-block;
              padding: 0px 5px;
              line-height: 25px;
              border-radius: 5px;
              background: #1d224c;
              color: #fff;
              text-align: center;
              margin: 5px 10px;
            }
          }
          .fun {
            padding: 10px;
            min-height: 60px;
            background: #fff;
            box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
            border-radius: 10px;
            margin: 10px 0;
            .div_fun {
              display: inline-block;
              padding: 0 5px;
              line-height: 25px;
              border-radius: 5px;
              background: #23b08d;
              color: #fff;
              text-align: center;
              margin: 5px 10px;
            }
          }
          .FBtn {
            position: absolute;
            bottom: 30px;
            right: 30px;
          }
        }
      }
      .white {
        width: 30px;
        height: 100%;
        background: #fff;
        float: left;
      }
      .right {
        width: 250px;
        height: 100%;
        background: #f5f5f5;
        border-radius: 0 10px 10px 0;
        float: left;
        padding: 30px;
        box-sizing: border-box;
        ul {
          width: 100%;
          margin-bottom: 15px;
          li {
            font-size: 14px;
            line-height: 30px;
            height: 30px;
            text-align: left;
            padding-left: 30px;
            border-radius: 5px;
            position: relative;
            span {
              position: absolute;
              right: 20px;
            }
          }
          // li:hover{
          //      color: #002774;

          // }
          .methodsColor {
            color: #002774;
            // background-color: #002774;
          }
        }
        div {
          min-height: 30px;
          h5,
          h6 {
            font-weight: normal;
            height: 15px;
          }
          h5 {
            font-size: 18px;
            color: #666;
            font-weight: bold;
          }
          h6 {
            font-size: 16px;
          }
        }
      }
      .FBtn {
        position: absolute;
        right: 30px;
        bottom: 30px;
      }
    }
    /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
    .tab-card::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    /*定义滚动条轨道 内阴影+圆角*/
    .tab-card::-webkit-scrollbar-track {
      border-radius: 10px;
    }

    /*定义滑块 内阴影+圆角*/
    .tab-card::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #d2d2d2;
    }
  }
  .bottom {
    height: 110px;
    display: flex;
    justify-content: space-between;
    .blank {
      width: 250px;
    }
    .label {
      width: 580px;
      font-size: 16px;
      line-height: 110px;
      .error {
        color: red;
      }
    }
    .save_cancel {
      width: 250px;
      display: flex;
      justify-content: space-between;
      line-height: 0px;
      align-items: center;
    }
  }
}
.table {
  height: 790px;
  padding: 60px 0px 160px;
  position: relative;
  .help {
    position: absolute;
    right: 5px;
    top: 0px;
    cursor: pointer;
  }
  .tit1 {
    height: 20px;
    line-height: 20px;
    text-align: left;
    font-size: 20px;
    margin-bottom: 10px;
    color: #000;
    position: absolute;
    top: 20px;
    left: 33px;
  }
  .tit2 {
    height: 20px;
    line-height: 20px;
    text-align: left;
    font-size: 20px;
    margin-bottom: 10px;
    color: #000;
    position: absolute;
    top: 20px;
    left: 290px;
  }
  input {
    border-bottom: 1px solid #000;
    text-align: center;
    outline: none;
  }
  .left {
    width: 250px;
    float: left;

    .tableList {
      width: 250px;
      height: 590px;
      border-radius: 10px;
      background: #f5f5f5;
      overflow-y: scroll;
      padding: 17px 0;
      .database {
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 18px;
      }
      .active {
        background: #0c0c54;
        border-radius: 10px;
        color: #fff;
      }
    }
    /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
    .tableList::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    /*定义滚动条轨道 内阴影+圆角*/
    .tableList::-webkit-scrollbar-track {
      border-radius: 10px;
    }

    /*定义滑块 内阴影+圆角*/
    .tableList::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #d2d2d2;
    }
  }
  .right {
    width: 860px;
    float: left;
    margin-left: 30px;
    .tit {
      height: 24px;
      line-height: 24px;
      text-align: left;
      font-size: 24px;
      margin-bottom: 10px;
      color: #000;
      input {
        border-bottom: 1px solid #000;
        text-align: center;
        outline: none;
      }
    }
    .tableDetail {
      width: 860px;
      height: 590px;
      border-radius: 10px;
      background: #f5f5f5;
      overflow: hidden;
      .big_circle {
        width: 96px;
        height: 96px;
        float: left;
        border-radius: 50%;
        background: #cccff0;
        position: relative;
        .small_circle {
          font-size: 12px;
          width: 78px;
          height: 78px;
          border-radius: 50%;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          margin: auto;
          background: #fff;
          box-shadow: 0 2px 10px 0px #999;
          line-height: 78px;
          text-align: center;
          white-space: nowrap;
          span {
            display: inline-block;
            width: 60px;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
          }
        }
      }
    }
  }
  .bottom {
    float: left;
    position: absolute;
    right: 30px;
    bottom: 60px;
    .FBtn {
      margin: 60px 0 0 40px;
    }
  }
}
.clear {
  .help {
    position: absolute;
    right: 5px;
    top: 65px;
    cursor: pointer;
  }
  .left {
    height: 586px;
    width: 250px;
    background: #f5f5f5;
    padding: 17px 0;
    overflow-y: scroll;
    border-radius: 10px;
    .field {
      height: 40px;
      line-height: 40px;
      // text-align: center;
      padding-left: 20%;
      font-size: 20px;
      position: relative;
      color: #666;
      cursor: pointer;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
    }
    .field_center {
      height: 40px;
      line-height: 40px;
      text-align: left;
      padding-left: 30%;
      font-size: 20px;
      position: relative;
      color: #666;
      margin-top: 200px;
    }
    .active {
      border-radius: 5px;
      background: #002774;
      color: #fff;
    }
  }
  .left::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  .left::-webkit-scrollbar-track {
    border-radius: 10px;
  }
  .left::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #d2d2d2;
  }
  .right {
    width: 930px;
    height: 586px;
    background-color: #e5e5e5;
    margin-bottom: 60px;
    border-radius: 10px;
    padding: 30px;
    font-size: 0;
    overflow-y: auto;
    position: relative;
    .wen {
      height: 16px;
      width: 100%;
      font-size: 14px;
      line-height: 16px;
      background: #f0f9eb;
      border-color: #e1f3d8;
      color: #67c23a;
      position: absolute;
      text-align: center;
      top: 0;
      left: 0;
    }
    .el-range-editor.el-input__inner {
      border: none;
    }
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      border: none;
    }
    // .el-input__prefix {
    //   display: none;
    // }
    .big-data {
      .el-input__inner {
        height: 50px;
        border-radius: 5px;
        border: none;
      }
      .el-date-editor .el-range-separator {
        line-height: 50px;
      }
    }
    .small-data {
      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 200px;
      }
      .el-input__inner {
        height: 50px;
        border-radius: 5px;
        border: none;
        text-align: center;
      }
    }
    // input {
    //   width: 160px;
    //   height: 50px;
    //   border-radius: 5px;
    //   text-align: center;
    //   margin-right: 30px;
    //   outline: none;
    // }
    //  input {
    //   width: 80px;
    //   height: 50px;
    //   border-radius: 10px;
    //   text-align: center;
    //   margin-right: 30px;
    //   outline: none;
    // }
    #dataInput1 {
      width: 160px;
      height: 50px;
      border-radius: 5px;
      text-align: center;
      margin-right: 30px;
      outline: none;
    }
    #dataInput2 {
      width: 100px;
      height: 50px;
      border-radius: 5px 0 0 5px;
      text-align: center;
      margin-right: 0px;
      outline: none;
      border-right: 1px solid #eee;
    }
    .minInp {
      width: 100px;
      height: 50px;
      border-radius: 5px;
      text-align: center;
      margin-right: 30px;
      outline: none;
    }
    input:focus {
      box-shadow: 0 0 10px 0 skyblue;
    }
    input:nth-last-child(1) {
      margin: 0 30px;
    }
    .noBorder {
      width: 60px;
      height: 50px;
      border-radius: 0 5px 5px 0;
      border: none;
      text-align: center;
      outline: none;
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
    }
    .noBorder::after {
      content: "";
    }
    .noBorder:focus {
      box-shadow: 0 0 10px 0 skyblue;
    }
    select {
      width: 100px;
      height: 50px;
      border-radius: 5px;
      border: none;
      text-align: center;
      margin-right: 30px;
      outline: none;
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
    }
    select:focus {
      box-shadow: 0 0 10px 0 skyblue;
    }
    option {
      background-color: rgba(0, 0, 0, 0.5);
      color: #fff;
    }
    .circleBtn {
      width: 80px;
      height: 50px;
      display: inline-block;
      vertical-align: middle;
      float: right;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .circleAdd,
    .circleDel {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      text-align: center;
      line-height: 20px;
      font-size: 30px;
      cursor: pointer;
    }
    .circleAdd:active {
      border-color: rgba(0, 206, 83, 0.5);
      color: rgba(0, 206, 83, 0.5);
    }
    .circleAdd {
      border: 2px solid #00ce53;
      color: #00ce53;
    }
    .circleDel:active {
      border-color: rgba(255, 18, 64, 0.5);
      color: rgba(255, 18, 64, 0.5);
    }
    .circleDel {
      border: 2px solid #ff1240;
      color: #ff1240;
    }
    .judge {
      margin-bottom: 30px;
      position: relative;
    }
  }
  .right::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  .right::-webkit-scrollbar-track {
    border-radius: 10px;
  }
  .right::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #d2d2d2;
  }
  .bottom {
    width: 100%;
    height: 43px;
    float: left;
    line-height: 43px;
    text-align: right;
  }
}

// ===数据关联===
.el-card__body {
  height: 570px !important;
  overflow-y: scroll;
  overflow-x: hidden;
  background-color: #f5f5f5;
}
.el-card__body::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
/*定义滚动条轨道 内阴影+圆角*/
.el-card__body::-webkit-scrollbar-track {
  border-radius: 10px;
}

/*定义滑块 内阴影+圆角*/
.el-card__body::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #d2d2d2;
}
.el-icon-arrow-down:before {
  display: none !important;
}
.el-menu {
  border: none !important;
  background-color: #f5f5f5;
}
.el-submenu__title {
  height: 0px;
  padding-left: 0px !important;
  background-color: #f5f5f5;
}
.el-menu-item {
  height: 30px !important;
  line-height: 30px !important;
}
.el-menu-item.is-active {
  color: #000;
}
.el-card__body {
  padding: 0px;
}
.remarks {
  text-align: right;
  position: absolute;
  right: 30px;
  bottom: 30px;
}
.text {
  font-size: 14px;
}
.my-info-dialog .el-dialog .el-dialog__body {
  padding: 30px 30px 80px 30px !important;
}
.el-dialog .el-dialog__body {
  padding: 30px;
}
</style>
    <style lang="less" scoped>
.ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-wrap: break-word;
}

.link-base-style-form {
  .el-form-item {
    margin-bottom: 12px;
  }

  padding-bottom: 20px;
  border-bottom: 1px solid #dcdcdc;
}

.super-flow-demo1 {
  width: 100%;
  height: 100%;
  background-color: #fff;
  @list-width: 200px;

  > .node-container {
    width: @list-width;
    float: left;
    height: 100%;
    text-align: center;
    background-color: #ffffff;
  }

  > .flow-container {
    height: 100%;
    overflow: hidden;
  }
  .super-flow__node {
    .flow-node {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      line-height: 40px;
      padding: 0 6px;
      font-size: 14px;
      text-align: center;
      background: #e7f8f7;
      overflow: hidden;
      // font-weight: bold;
      border: 1px solid #c1dad7;
      font-family: "Trebuchet MS", Verdana, Arial, Helvetica, sans-serif;
    }
  }
}

.node-item {
  @node-item-height: 30px;
  font-size: 14px;
  display: inline-block;
  height: @node-item-height;
  min-width: 120px;
  margin-top: 20px;
  background-color: #ffffff;
  line-height: @node-item-height;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  user-select: none;
  text-align: center;
  z-index: 6;
  &:hover {
    box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.4);
  }
}
.el-select {
  width: 100%;
}
.by1 {
  padding: 10px 40px;
  border: none;
  display: inline-block;
  position: absolute;
  right: 30px;
  bottom: 30px;
  background: #39ae78;
  color: #fff;
  border: none;
}
.by2 {
  padding: 10px 40px;
  border: none;
  display: inline-block;
  position: absolute;
  right: 30px;
  bottom: 30px;
  background: #999;
  color: #fff;
  border: none;
}
.by1:hover {
  background: #39ae78;
  color: #fff;
}
.addBtnT {
  padding: 10px 40px;
  border: none;
  background: #39ae78;
  color: #fff;
}
.addBtnF {
  padding: 10px 40px;
  border: none;
  background: #999;
  color: #fff;
}
.el-button.is-disabled,
.el-button.is-disabled:hover,
.el-button.is-disabled:focus {
  padding: 10px 40px;
  border: none;
  background: #999;
  color: #fff;
}
.el-scrollbar__wrap {
  margin-bottom: 0 !important;
}
.help1 {
  max-height: 600px;
  // padding: 30px;
  span {
    display: block;
    font-size: 14px;
    margin: 5px 0;
  }
  img {
    width: 550px;
  }
}
</style>